import React, { useEffect, useState, useRef, Fragment, useLayoutEffect, useCallback, useMemo } from 'react';
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom";
import { UnControlled as CodeMirror } from 'react-codemirror2';
import { useDispatch, useSelector } from 'react-redux';
import 'codemirror/addon/search/searchcursor';
import WorkflowErrorBoundary from '../WorkflowErrorBoundary';
import config from '../../config/environment';
import axios from 'axios';
import mixpanel from 'mixpanel-browser';
import { hotjar } from 'react-hotjar';
import styles from '../Panel.module.css';
import notrigger from '../NoTrigger.module.css';
import { makeStyles, useTheme, Theme, createStyles } from '@material-ui/core/styles';
import { Paper, Modal, Dialog, DialogActions,DialogContent, DialogContentText, DialogTitle, FormHelperText,Popper, Snackbar, OutlinedInput, Select, ListItemIcon, Input, InputLabel, CircularProgress, InputAdornment, Divider, Typography, Stepper, Step, StepContent, StepButton, StepIcon, Button, MenuItem, FormControl, TextField, Avatar, Grid, Box, Tooltip, TextareaAutosize, Chip } from '@material-ui/core'
import Authorizer from '../Authorizer'
import SettingsEthernetRoundedIcon from '@material-ui/icons/SettingsEthernetRounded';
import Inspector from 'react-json-inspector';
import '../helpers/json-inspector.css';
import { v4 as uuid } from 'uuid';
import { Alert, AlertTitle } from '@material-ui/lab';
import AppsRoundedIcon from '@material-ui/icons/AppsRounded';
import BoltRoundedIcon from '@material-ui/icons/OfflineBoltOutlined';
import IconButton from '@material-ui/core/IconButton';
import AppsIcon from '@material-ui/icons/AppsRounded';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import CreateRoundedIcon from '@material-ui/icons/CreateRounded';
import FlashOffRoundedIcon from '@material-ui/icons/FlashOffRounded';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@material-ui/icons/KeyboardArrowUpRounded';
import Skeleton from '@material-ui/lab/Skeleton';
import DataInspector from './DataInspector';
import { alertName } from '../../redux/ducks/notification';
import Form from "@rjsf/material-ui"
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {
    nodeAdded, edgeAdded, elementUpdated,notification, nameUpdated, elementDeleted, fetchWorkflow, nodeEdgeAdded, saveWorkflow, elementSelected, testNode, fetchTriggerChoices,
    selectWorkflowElements, selectElementById, selectWorkflowName, selectWorkflowId, selectParentTree, selectWorkflowTemplate, selectWorkflowTemplateNodes, selectWorkflowActive, selectCurrentElement, activeUpdated
} from '../../features/workflow/workflowSlice'
import { createTrigger } from '../../features/workflow/workflowSlice'
import { BUILT_IN_TRIGGER_APPS, normalizeBuiltInAppUrl } from '../../constants/triggerApps'

import { FieldsRender } from '../helpers/panel-functions'
import { selectAllTriggers } from '../../features/allApps/allAppsSlice'
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import { WarningRounded, ErrorRounded, CheckCircleRounded } from '@material-ui/icons';
import { trackAppSelected, trackEventSelected, trackCredentialConnected, trackTestDataCreated } from '../../utils/posthog';




function timeSince(date) {

    var seconds = Math.floor((new Date() - date) / 1000);
  
    var interval = seconds / 31536000;
  
    if (interval > 1) {
      return Math.floor(interval) + " years";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes";
    }
    return Math.floor(seconds) + " seconds";
  }

  function getModalStyle() {
    const top = 30;
    const left = 30;
  
    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

function Carat(props) {
    const isActive = props.active;
    if (isActive) {
      return <KeyboardArrowUpRoundedIcon />;
    }
    return <KeyboardArrowDownRoundedIcon />;
  }

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    removeappbutton: {
        '& > *': {
            margin: theme.spacing(1),

        },
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
    selectInput: {
        width: '100%',
        marginTop: '50px',
    },
    paper: {
        padding: theme.spacing(0.5),
        margin: theme.spacing(0.5),
        textAlign: 'left',
        color: theme.palette.text.secondary,
    },
    modalstyle: {
        position: 'absolute',
        width: 600,
        maxWidth: '90vw',
        borderRadius: 8,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(3, 4, 3),
      },
    loadbutton: {
        display: 'flex',
        alignItems: 'center',
        margin: '0 auto',
        justifyContent: 'center',
        width: '90%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '4px',
        border: '1px solid #0069ea',
        height: '40px',
        marginBottom: '20px',
        cursor: 'pointer'
      },
    papermain: {
        padding: theme.spacing(0.5),
        margin: theme.spacing(0.5),
        paddingLeft: '25px',
        textAlign: 'left',
        color: theme.palette.text.secondary,
    },
    cardblack: {
        position: 'relative',
        width: '100%',
        paddingBottom: '35px',
        cursor: 'pointer',
        height: '100%',
        // paddingTop: '9px',
        borderRadius: '4px'
    },
    triggersContainer: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        maxWidth: '100%',
        minWidth: 0,
    },
    resetContainer: {
        padding: theme.spacing(1),
        borderRadius: '8px',
        marginTop: '-10px',
        marginBottom: '5px',
    },
    selectInput: {
        '*': {
            display: 'flex'
        }
    },
    popper: {
        border: '1px solid lightgray',
        borderRadius: '4px',
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
        zIndex: 999,
        height: '400px',
        boxShadow: '0 5px 5px 5px lightgray',
        width: '500px'
    },
    modal: {
        position: 'absolute',
        width: 400,
        maxWidth: '90vw',
        backgroundColor: theme.palette.background.paper,
        border: '0px solid #000',
        borderRadius: '8px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 3, 2),
    },
    headerbox: {
        width: '100%',
        maxWidth: '100%',
        marginLeft: '20px',
        marginBottom: '20px',
        display: 'block',
        minWidth: 0,
        boxSizing: 'border-box'
    }
}));




function TriggerPanel({ selectedNode, deleteNode, sendNode, parentTree, user, tenant, setWFActive, onPaneClick, sendLoggedOutToAuthorizer, breakpoint, inlineLayout = false, onActivateForListening }) {
    const theme = useTheme();
    const node = useSelector(selectElementById(selectedNode.id))
    const [name, setName] = useState(node.data.name);
    const [app, setApp] = useState(node.data.app);
    const [timestamp, setTimeStamp ]= useState(new Date())
    const [triggerChoiceTime, setTriggerChoiceTime ]= useState(node.data.triggerChoiceTime)
    const [type, setType] = useState(node.data.type)
    const [label, setLabel] = useState(node.data.label);
    const [icon, setIcon] = useState(node.data.icon);
    const allApps = useSelector(selectAllTriggers)
    const [triggers, setTriggers] = useState([]);
    const [trigger, setTrigger] = useState({ key: node.data.action, label: node.data.action });
    const [triggerlabel, setTriggerLabel] = useState(node.data.triggerlabel)
    const [credentialId, setCredentialId] = useState(node.data.credential)
    const [authname, setAuthname] = useState(node.data.authname)
    const [pollingParams, setPollingParams] = useState(node.data.pollingParams)
    // For polling triggers, performList IS the triggerResource - initialize it properly
    const [performList, setPerformList] = useState(node.data.performList)
    const [webhookKey, setWebhookKey] = useState(node.data.webhookKey)
    const [custombutton, setCustomButton] = useState(node.data.custombutton)
    const [unsubscribe, setUnsubscribe] = useState(node.data.unsubscribe)
    const [loading, setLoading] = useState(true);
    const [executions, setExecutions] = useState([]);
    const [recentWebhookPayloads, setRecentWebhookPayloads] = useState([]);
    const [loadingRecentPayloads, setLoadingRecentPayloads] = useState(false);
    const hasFetchedRecentPayloadsRef = useRef(false);
    const [recentFormSubmissions, setRecentFormSubmissions] = useState([]);
    const [loadingFormSubmissions, setLoadingFormSubmissions] = useState(false);
    const hasFetchedFormSubmissionsRef = useRef(false);
    const [nosave, setNoSave] = useState(0)
    const [creatingWebhookTrigger, setCreatingWebhookTrigger] = useState(false);
    const [triggerMessage, setTriggerMessage] = useState(node.data.triggerMessage)
    const [triggerChoices, setTriggerChoices] = useState(node.data.triggerChoices)
    const [url, setURL] = useState(node.data.url)
    const workflowID = useSelector(selectWorkflowId)
    const dispatch = useDispatch();
    const [awaitingTrigger, setAwaitingTrigger] = useState(false)
    const workflow = useSelector(selectWorkflowTemplateNodes)
    const [modalStyle] = React.useState(getModalStyle);
    const [modalopen, setModalOpen] = React.useState(false);
    // Initialize fields from node data, but allow undefined/null so fields can be loaded from triggers
    const [fields, setFields] = useState(node.data.fields || undefined)
    const [hasauth, setHasAuth] = useState(node.data.hasauth)
    const [testData, setTestData] = useState(node.data.testData)
    const [triggerchoice, setChoice] = useState(node.data.triggerchoice)
    const bottomRef = useRef(null);
    const iconErrorRef = useRef(false);
    const isSyncingFromReduxRef = useRef(false); // Flag to prevent infinite loop when syncing from Redux
    const isManualSaveRef = useRef(false); // Flag to prevent sync useEffect from overwriting manual saves
    const prevFieldsRef = useRef(fields); // Track previous fields to detect field-only changes
    const prevNodeStateRef = useRef({ name, app, label, icon, hasauth, trigger, credentialId, authname }); // Track other state to detect non-field changes
    const latestFieldsRef = useRef(fields); // Latest fields for flush-on-close so array edits persist
    const saveFieldsOnlyTimeoutRef = useRef(null); // Debounce saveFieldsOnly to avoid API storm
    const hasAutoSelectedRef = useRef(false); // Flag to prevent re-auto-selecting trigger choices

    // Keep ref in sync so flush-on-close can persist latest array edits
    useEffect(() => {
        latestFieldsRef.current = fields;
    }, [fields]);

    // Debounced persist: avoid calling saveFieldsOnly on every form onChange (prevents API storm)
    const DEBOUNCE_SAVE_MS = 500;
    const scheduleSaveFieldsOnly = useCallback((nextFields) => {
        if (saveFieldsOnlyTimeoutRef.current) clearTimeout(saveFieldsOnlyTimeoutRef.current);
        saveFieldsOnlyTimeoutRef.current = setTimeout(() => {
            saveFieldsOnlyTimeoutRef.current = null;
            if (Array.isArray(nextFields) && selectedNode?.id) {
                saveFieldsOnly(nextFields);
            }
        }, DEBOUNCE_SAVE_MS);
    }, [selectedNode?.id]);

    // setFields that supports functional updates and debounced save (so array edits persist and we don't storm the API)
    const setFieldsAndPersist = useCallback((updatedOrUpdater) => {
        setFields((prev) => {
            const next = typeof updatedOrUpdater === 'function' ? updatedOrUpdater(prev) : updatedOrUpdater;
            if (Array.isArray(next)) {
                scheduleSaveFieldsOnly(next);
            }
            return next;
        });
    }, [scheduleSaveFieldsOnly]);
    const [openalert, setOpen] = React.useState(false);
    const [recentAppsUpdated, setRecentAppsUpdated] = useState(0);

    // Display label for event/trigger (avoids "undefined" when triggerlabel not set, e.g. webhook from agent)
    const eventLabel = triggerlabel || trigger?.label || (app === 'webhook' ? 'Webhook Received' : (app === 'workload-forms' ? 'Form submission' : ((name && name.split(' in ')[0]) || 'Trigger')));
    
    // Helper function to save recent apps to localStorage
    const saveRecentApp = (appObj, type = 'trigger') => {
        const storageKey = `recentApps_${type}`;
        let recentApps = [];
        try {
            const stored = localStorage.getItem(storageKey);
            if (stored) {
                recentApps = JSON.parse(stored);
            }
        } catch (e) {
            console.error('Error reading recent apps:', e);
        }
        
        // Remove if already exists
        recentApps = recentApps.filter(item => item.name !== appObj.name);
        
        // Add to beginning
        recentApps.unshift({
            name: appObj.name,
            app: appObj.app,
            icon: appObj.icon,
            auth: appObj.auth,
            custombutton: appObj.custombutton,
            formDataEndpoint: appObj.formDataEndpoint,
            category: appObj.category
        });
        
        // Keep only last 8
        recentApps = recentApps.slice(0, 8);
        
        try {
            localStorage.setItem(storageKey, JSON.stringify(recentApps));
        } catch (e) {
            console.error('Error saving recent apps:', e);
        }
    };
    
    // Helper function to get recent apps from localStorage
    const getRecentApps = (type = 'trigger') => {
        const storageKey = `recentApps_${type}`;
        try {
            const stored = localStorage.getItem(storageKey);
            if (stored) {
                return JSON.parse(stored);
            }
        } catch (e) {
            console.error('Error reading recent apps:', e);
        }
        return [];
    };
    
    // Helper function to handle chip click - select the app
    const handleChipClick = (appObj) => {
        // Save to recent apps
        saveRecentApp(appObj, 'trigger');
        
        // Set flag to prevent sync useEffect from interfering
        isManualSaveRef.current = true;
        
        // Clear all related state when app changes
        setCredentialId(null);
        setAuthname(null);
        setTrigger({ key: '', label: '' });
        setTriggerMessage('');
        setTriggerChoices('');
        setChoice('');
        setTestData('');
        
        // Update app-related state
        setApp(appObj.app);
        setLabel(appObj.name);
        setIcon(appObj.icon);
        setCustomButton(appObj.custombutton);
        setURL(appObj.formDataEndpoint);
        setHasAuth(appObj.auth === true);
        
        // Update node name
        setNodeNameAuto(appObj.name, undefined);
        sendTriggerData(appObj.app);
        
        // Track app selected
        trackAppSelected(appObj.name, appObj.app, 'trigger');
        
        // Save the changes with description after state updates
        setTimeout(() => {
            saveNode('changed app');
            setStep(1);
            // Clear flag after save completes
            setTimeout(() => {
                isManualSaveRef.current = false;
            }, 100);
        }, 0);
        
        // Force re-render recent apps
        setRecentAppsUpdated(Date.now());
    };
    
    // Get recent apps with memoization
    const recentApps = React.useMemo(() => getRecentApps('trigger'), [recentAppsUpdated]);
    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    let query = useQuery();
    let work_id = query.get("id")
  
    const colors = [
        'primary',
        'secondary'
    ];

    const [color, setColor] = useState(0);
    const [triggersopen, setTriggersOpen] = useState(false)
    const [loadedTriggers, setLoadedTriggers] = useState(false)

    useEffect(() => {
        if (loading === false) {
            const interval = setInterval(() => {
                setColor((v) => (v === 2 ? 0 : v + 1));
            }, 1500);
            
            return () => clearInterval(interval);
        } else {
            setColor(0);
        }
    }, [loading]);



    const saveNode = (description, fieldsOverride = undefined) => {
        // When closing/saving after form edit, caller can pass latest fields so array edits persist
        const fieldsToSave = fieldsOverride !== undefined ? fieldsOverride : fields;
        // Built-in apps: never persist performList (getDD would 500). For webhook, persist triggerResource
        // from API (e.g. "createWebhook") so action=webhookReceived and triggerResource=createWebhook per formDataEndpoint.
        const isBuiltInApp = app === BUILT_IN_TRIGGER_APPS.SCHEDULE || app === BUILT_IN_TRIGGER_APPS.WEBHOOK || app === BUILT_IN_TRIGGER_APPS.WORKLOAD_FORMS;
        let newTriggerResource = '';
        let effectivePerformList = performList;
        if (app === BUILT_IN_TRIGGER_APPS.SCHEDULE || app === BUILT_IN_TRIGGER_APPS.WORKLOAD_FORMS) {
            newTriggerResource = '';
            effectivePerformList = '';
        } else if (app === BUILT_IN_TRIGGER_APPS.WEBHOOK) {
            effectivePerformList = ''; // never performList for built-in webhook
            // Webhook: triggerResource = API trigger's .action (e.g. "createWebhook"); action = trigger key (e.g. "webhookReceived")
            if (Object.keys(triggers).length > 0 && trigger && triggers[trigger.key] && triggers[trigger.key].action) {
                newTriggerResource = triggers[trigger.key].action;
            } else if (node?.data?.triggerResource && node.data.triggerResource !== '') {
                newTriggerResource = node.data.triggerResource;
            }
        } else if (type === 'polling') {
            // For polling triggers, performList is the source of truth
            if (performList && performList !== '') {
                newTriggerResource = performList;
            } else if (node?.data?.performList && node.data.performList !== '') {
                // If state performList is empty but node.data has it, use node.data
                newTriggerResource = node.data.performList;
            } else if (node?.data?.triggerResource && node.data.triggerResource !== '') {
                // Fallback to existing triggerResource if performList is unavailable
                newTriggerResource = node.data.triggerResource;
            } else if (Object.keys(triggers).length > 0 && trigger && triggers[trigger.key] && triggers[trigger.key].action) {
                // Last resort: try to get from triggers if loaded
                newTriggerResource = triggers[trigger.key].action;
            }
        } else {
            // Non-polling triggers: use triggers data if available, otherwise preserve existing
            if (Object.keys(triggers).length > 0 && trigger && triggers[trigger.key] && triggers[trigger.key].action) {
                newTriggerResource = triggers[trigger.key].action;
            } else if (node?.data?.triggerResource && node.data.triggerResource !== '') {
                newTriggerResource = node.data.triggerResource;
            }
        }
        
        // NEVER save empty triggerResource for polling triggers if we have performList (and not built-in)
        if (!isBuiltInApp && type === 'polling' && (!newTriggerResource || newTriggerResource === '') && performList && performList !== '') {
            newTriggerResource = performList;
        }
        
        // Ensure selectedNode.id exists before dispatching
        if (!selectedNode || !selectedNode.id) {
            return;
        }
        
        dispatch(elementUpdated(selectedNode.id,
            {
                name: name,
                type: type,
                app: app,
                label: label,
                triggerlabel: triggerlabel,
                icon: icon,
                hasauth: hasauth,
                action: trigger?.key || '',
                triggerResource: newTriggerResource,
                credential: credentialId,
                authname: authname,
                fields: fieldsToSave,
                testData: testData,
                url: url,
                pollingParams: pollingParams,
                triggerMessage: triggerMessage,
                performList: effectivePerformList,
                unsubscribe: unsubscribe,
                webhookKey: webhookKey,
                triggerChoices: triggerChoices,
                triggerchoice: triggerchoice,
                triggerChoiceTime: triggerChoiceTime
            },
            null,
            description
        ));
    }
    
    // Save only fields (for field mapping changes) - preserves rest of node state
    const saveFieldsOnly = (newFields) => {
        dispatch(elementUpdated(selectedNode.id,
            {
                ...node.data, // Preserve all existing node data
                fields: newFields // Only update fields
            },
            null,
            'changed field mapping'
        ));
    }

    // Function to check if all required fields are filled
    const areRequiredFieldsFilled = () => {
        if (!fields || fields.length === 0) return true;
        
        return fields.every(field => {
            // Skip hidden fields
            if (field.hidden) return true;
            
            // Check if field is required
            if (field.required) {
                // Check if field has a value
                if (field.value === undefined || field.value === null || field.value === '') {
                    return false;
                }
            }
            return true;
        });
    }

    // Flush form state (blur + trigger change) then run saveCallback(latestFields) so array edits persist to workflow JSON
    const flushFormThenSave = (saveCallback) => {
        if (saveFieldsOnlyTimeoutRef.current) {
            clearTimeout(saveFieldsOnlyTimeoutRef.current);
            saveFieldsOnlyTimeoutRef.current = null;
        }
        const activeEl = document.activeElement;
        if (activeEl && activeEl.blur) activeEl.blur();
        const codeMirrorInput = activeEl?.closest?.('.CodeMirror')?.CodeMirror?.getInputField?.();
        if (codeMirrorInput?.blur) codeMirrorInput.blur();
        document.querySelectorAll('.CodeMirror').forEach((cm) => {
            try {
                if (cm?.CodeMirror?.getInputField?.()) cm.CodeMirror.getInputField().blur();
            } catch (_) {}
        });
        const allForms = document.querySelectorAll('form, [class*="rjsf"]');
        allForms.forEach((form) => {
            try {
                if (form.dispatchEvent) form.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
            } catch (_) {}
        });
        setTimeout(() => {
            const latest = latestFieldsRef.current;
            if (typeof saveCallback === 'function') saveCallback(latest);
        }, 150);
    }

    // CRITICAL FIX: Restore triggerResource from performList IMMEDIATELY when node loads
    // Use useLayoutEffect to run synchronously BEFORE any save operations
    useLayoutEffect(() => {
        if (!node?.data || !selectedNode?.id) return;
        const isScheduleOrForms = node.data.app === BUILT_IN_TRIGGER_APPS.SCHEDULE || node.data.app === BUILT_IN_TRIGGER_APPS.WORKLOAD_FORMS;
        const isWebhook = node.data.app === BUILT_IN_TRIGGER_APPS.WEBHOOK;
        // Schedule/workload-forms: never have performList or triggerResource
        if (isScheduleOrForms && (node.data.performList || node.data.triggerResource)) {
            const hasBad = (node.data.performList && node.data.performList !== '') || (node.data.triggerResource && node.data.triggerResource !== '');
            if (hasBad) {
                dispatch(elementUpdated(selectedNode.id, { ...node.data, performList: '', triggerResource: '' }, null, null));
                setPerformList('');
            }
            return;
        }
        // Webhook: never performList; allow triggerResource (e.g. "createWebhook") per formDataEndpoint
        if (isWebhook && node.data.performList && node.data.performList !== '') {
            dispatch(elementUpdated(selectedNode.id, { ...node.data, performList: '' }, null, null));
            setPerformList('');
            return;
        }
        if (type === 'polling') {
            // If triggerResource is empty but performList has a value, restore triggerResource from performList
            // This is the source of truth for polling triggers
            const hasTriggerResource = node.data.triggerResource && node.data.triggerResource !== '';
            const hasPerformList = node.data.performList && node.data.performList !== '';
            
            if (!hasTriggerResource && hasPerformList) {
                // Restore triggerResource from performList - CRITICAL: do this synchronously before any renders
                // Use the performList from node.data to ensure we're using the latest value
                const valueToRestore = node.data.performList;
                dispatch(elementUpdated(selectedNode.id, {
                    ...node.data,
                    triggerResource: valueToRestore
                }, null, null)); // null description = no undo history
                // Also ensure performList state is set
                if (!performList || performList !== valueToRestore) {
                    setPerformList(valueToRestore);
                }
            } else if (hasTriggerResource && (!performList || performList === '')) {
                // If triggerResource exists but performList is empty, sync performList from triggerResource
                setPerformList(node.data.triggerResource);
            } else if (!hasTriggerResource && performList && performList !== '') {
                // If node.data doesn't have triggerResource but state has performList, restore from state
                dispatch(elementUpdated(selectedNode.id, {
                    ...node.data,
                    triggerResource: performList
                }, null, null)); // null description = no undo history
            }
        }
    }, [node?.data?.triggerResource, node?.data?.performList, node?.data?.app, type, selectedNode?.id, dispatch, performList]) // Run when these specific values change

    //whenever a field is updated, send the change to redux
    // Detect if only fields changed (field mapping) vs other changes (app, event, etc.)
    useEffect(() => {
        // Skip saving if we're currently syncing from Redux (prevents infinite loop)
        if (isSyncingFromReduxRef.current) {
            // Update refs to reflect synced state
            prevFieldsRef.current = fields;
            prevNodeStateRef.current = { name, app, label, icon, hasauth, trigger, credentialId, authname };
            return;
        }
        
        // Skip if node is not available (but allow saving if node exists but data might be empty)
        if (!node) {
            prevFieldsRef.current = fields;
            prevNodeStateRef.current = { name, app, label, icon, hasauth, trigger, credentialId, authname };
            return;
        }
        
        // For polling triggers, ensure triggerResource and performList are synced before saving
        if (type === 'polling') {
            // If performList has value but triggerResource is empty/doesn't match, sync them
            if (performList && performList !== '' && (!node?.data?.triggerResource || node.data.triggerResource !== performList)) {
                // Don't call saveNode yet - update triggerResource directly first (no undo history)
                dispatch(elementUpdated(selectedNode.id, {
                    ...node.data,
                    triggerResource: performList
                }, null, null)); // null description = no undo history
                // Update refs and return early to avoid saving again
                prevFieldsRef.current = fields;
                prevNodeStateRef.current = { name, app, label, icon, hasauth, trigger, credentialId, authname };
                return;
            } else if (node?.data?.triggerResource && (!performList || performList !== node.data.triggerResource)) {
                // If triggerResource exists but performList doesn't match, sync performList
                // This will trigger this useEffect again, but the guard above will catch it
                setPerformList(node.data.triggerResource);
                prevFieldsRef.current = fields;
                prevNodeStateRef.current = { name, app, label, icon, hasauth, trigger, credentialId, authname };
                return;
            }
        }
        
           // Check if only fields changed (field mapping/value change)
           const fieldsChanged = JSON.stringify(prevFieldsRef.current) !== JSON.stringify(fields);
           const triggerKey = trigger?.key || '';
           const otherStateChanged = 
               prevNodeStateRef.current.name !== name ||
               prevNodeStateRef.current.app !== app ||
               prevNodeStateRef.current.label !== label ||
               prevNodeStateRef.current.icon !== icon ||
               prevNodeStateRef.current.hasauth !== hasauth ||
               prevNodeStateRef.current.trigger?.key !== triggerKey ||
               prevNodeStateRef.current.credentialId !== credentialId ||
               prevNodeStateRef.current.authname !== authname;
           
           // Track credential connected when credentialId changes from empty to non-empty
           if (prevNodeStateRef.current.credentialId !== credentialId && 
               credentialId && credentialId !== '' && 
               (!prevNodeStateRef.current.credentialId || prevNodeStateRef.current.credentialId === '')) {
             trackCredentialConnected(label, credentialId);
           }
           
           // Track test data created when testData is set successfully
           if (testData && testData !== '' && 
               (!node?.data?.testData || node.data.testData === '')) {
             trackTestDataCreated('trigger');
           }
        
        // Only save if there are actual changes (field-only changes are persisted via debounced setFieldsAndPersist to avoid API storm)
        if (fieldsChanged && !otherStateChanged) {
            prevFieldsRef.current = fields;
        } else if (otherStateChanged) {
            // Other state changed - save entire node without undo history (undo is handled by explicit user actions)
            saveNode(null);
            prevFieldsRef.current = fields;
            prevNodeStateRef.current = { name, app, label, icon, hasauth, trigger, credentialId, authname };
        } else {
            // No actual changes detected - just update refs
            prevFieldsRef.current = fields;
            prevNodeStateRef.current = { name, app, label, icon, hasauth, trigger, credentialId, authname };
        }
    }, [name, app, label, icon, hasauth, trigger, credentialId, authname, fields, performList])

    //refresh a field from redux after making async call (i.e. testNode)
    // Also sync all state from Redux when node changes (e.g., after undo/redo)
    useEffect(() => {
        if (!node || !node.data) return;
        
        // Check if we're already syncing to prevent loops
        if (isSyncingFromReduxRef.current) {
            return;
        }
        
        // Don't sync if we're in the middle of a manual save
        if (isManualSaveRef.current) {
            return;
        }
        
        // Check if anything actually changed before syncing
        const hasChanges = 
            node.data.name !== name ||
            node.data.app !== app ||
            node.data.label !== label ||
            node.data.icon !== icon ||
            node.data.custombutton !== custombutton ||
            node.data.type !== type ||
            node.data.action !== (trigger?.key || '') ||
            node.data.triggerlabel !== triggerlabel ||
            node.data.credential !== credentialId ||
            node.data.authname !== authname ||
            node.data.url !== url ||
            node.data.pollingParams !== pollingParams ||
            node.data.performList !== performList ||
            node.data.webhookKey !== webhookKey ||
            node.data.unsubscribe !== unsubscribe ||
            node.data.hasauth !== hasauth ||
            node.data.triggerMessage !== triggerMessage ||
            node.data.triggerChoices !== triggerChoices ||
            node.data.triggerchoice !== triggerchoice ||
            node.data.triggerChoiceTime !== triggerChoiceTime ||
            node.data.testData !== testData ||
            (node.data.fields && JSON.stringify(node.data.fields) !== JSON.stringify(fields));
        
        // Only sync if something actually changed
        if (!hasChanges) {
            // Still update refs even if no changes
            prevFieldsRef.current = node.data.fields || fields;
            prevNodeStateRef.current = { 
                name: node.data.name, 
                app: node.data.app, 
                label: node.data.label, 
                icon: node.data.icon, 
                hasauth: node.data.hasauth, 
                trigger: { key: node.data.action, label: node.data.triggerlabel || node.data.action },
                credentialId: node.data.credential, 
                authname: node.data.authname 
            };
            return;
        }
        
        // Set flag to prevent save useEffect from firing during Redux sync
        isSyncingFromReduxRef.current = true;
        
        // Update refs first to prevent save useEffect from detecting changes
        prevFieldsRef.current = node.data.fields || fields;
        prevNodeStateRef.current = { 
            name: node.data.name, 
            app: node.data.app, 
            label: node.data.label, 
            icon: node.data.icon, 
            hasauth: node.data.hasauth, 
            trigger: { key: node.data.action, label: node.data.triggerlabel || node.data.action },
            credentialId: node.data.credential, 
            authname: node.data.authname 
        };
        
        // Sync all state from Redux node data when node changes (including after undo/redo)
        if (node.data.name !== name) setName(node.data.name);
        if (node.data.app !== app) setApp(node.data.app);
        if (node.data.label !== label) setLabel(node.data.label);
        // Always sync icon, even if it's empty string (to fix broken icon display)
        if (node.data.icon !== icon) {
            setIcon(node.data.icon || '');
            // Reset icon error ref when icon changes from Redux
            iconErrorRef.current = false;
        }
        if (node.data.custombutton !== custombutton) setCustomButton(node.data.custombutton);
        if (node.data.type !== type) setType(node.data.type);
        if (node.data.action !== (trigger?.key || '')) {
            setTrigger({ key: node.data.action, label: node.data.triggerlabel || node.data.action });
        }
        if (node.data.triggerlabel !== triggerlabel) setTriggerLabel(node.data.triggerlabel);
        if (node.data.credential !== credentialId) setCredentialId(node.data.credential);
        if (node.data.authname !== authname) setAuthname(node.data.authname);
        if (node.data.url !== url) setURL(node.data.url);
        if (node.data.pollingParams !== pollingParams) setPollingParams(node.data.pollingParams);
        if (node.data.performList !== performList) setPerformList(node.data.performList);
        if (node.data.webhookKey !== webhookKey) setWebhookKey(node.data.webhookKey);
        if (node.data.unsubscribe !== unsubscribe) setUnsubscribe(node.data.unsubscribe);
        if (node.data.hasauth !== hasauth) setHasAuth(node.data.hasauth);
        if (node.data.triggerMessage !== triggerMessage) setTriggerMessage(node.data.triggerMessage);
        if (node.data.triggerChoices !== triggerChoices) setTriggerChoices(node.data.triggerChoices);
        if (node.data.triggerchoice !== triggerchoice) setChoice(node.data.triggerchoice);
        if (node.data.triggerChoiceTime !== triggerChoiceTime) setTriggerChoiceTime(node.data.triggerChoiceTime);
        if (node.data.testData !== testData) setTestData(node.data.testData);
        
        // Sync fields if they changed
        // IMPORTANT: Only sync fields from node.data if they exist and are not empty
        // If fields are undefined/null/empty, let the trigger-based field loading handle it
        if (node.data.fields && Array.isArray(node.data.fields) && node.data.fields.length > 0) {
            if (JSON.stringify(node.data.fields) !== JSON.stringify(fields)) {
                setFields(node.data.fields);
            }
        } else if (!node.data.fields && trigger && Object.keys(triggers).length > 0 && triggers[trigger.key]) {
            // If node.data.fields is missing/empty but we have a trigger, load fields from triggers
            // This handles the case where AI-generated nodes don't have fields set initially
            const triggerFields = triggers[trigger.key].fields;
            if (triggerFields && (!fields || fields.length === 0)) {
                setFields(triggerFields);
            }
        }
        
        // Reset auto-select flag when triggerChoices change (new fetch)
        if (node.data.triggerChoices && Array.isArray(node.data.triggerChoices) && node.data.triggerChoices.length > 0) {
            // If triggerChoices are populated but testData/triggerchoice don't match, reset auto-select flag
            if (!node.data.testData || !node.data.triggerchoice) {
                hasAutoSelectedRef.current = false;
            }
        }
        
        // Clear flag after sync completes (use requestAnimationFrame to ensure state updates have propagated)
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                isSyncingFromReduxRef.current = false;
            });
        });
    }, [node]) 

    const getExecutions = (timestamp) => {
        return axios.request({
            method: 'post',
            url: 'https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/djangocaller',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                operation: 'getExecutions',
                data: {
                    workflow_id: workflowID,
                    timestamp: timestamp
                }
            }
        })
    }
    
    // Fetch recent webhook executions for webhook triggers
    // forceRefresh: bypass cache; silent: when true (e.g. background poll), don't set loading state to avoid UI bounce
    const fetchRecentWebhookPayloads = async (forceRefresh = false, silent = false) => {
        if (app !== 'webhook' || type !== 'webhook') {
            hasFetchedRecentPayloadsRef.current = false;
            return [];
        }
        
        // Prevent duplicate calls unless forceRefresh is true
        if (!forceRefresh && (loadingRecentPayloads || hasFetchedRecentPayloadsRef.current)) {
            return recentWebhookPayloads; // Return existing payloads if already fetched
        }
        
        hasFetchedRecentPayloadsRef.current = true;
        if (!silent && !loadingRecentPayloads) {
            setLoadingRecentPayloads(true);
        }
        
        try {
            // Get executions from the last 30 days
            const thirtyDaysAgo = new Date();
            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
            const timestamp = thirtyDaysAgo.toISOString();
            
            const response = await getExecutions(timestamp);
            if (response && response.data && Array.isArray(response.data)) {
                const currentNodeId = node.id;
                const webhookPayloads = response.data
                    .filter(exec => exec.state && exec.state.nodes && exec.state.nodes[currentNodeId] && exec.state.nodes[currentNodeId].outputFields)
                    .map(exec => ({
                        id: exec.id || exec._id,
                        payload: exec.state.nodes[currentNodeId].outputFields,
                        date: exec.date_run || exec.created_at,
                        timestamp: exec.timestamp || new Date(exec.date_run || exec.created_at).getTime()
                    }))
                    .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0))
                    .slice(0, 10);
                
                setRecentWebhookPayloads(webhookPayloads);
                return webhookPayloads; // Return payloads for immediate use
            } else {
                setRecentWebhookPayloads([]);
                return [];
            }
        } catch (error) {
            console.error('Error fetching recent webhook payloads:', error);
            setRecentWebhookPayloads([]);
            hasFetchedRecentPayloadsRef.current = false;
            return [];
        } finally {
            if (!silent) setLoadingRecentPayloads(false);
        }
    }

    const fetchRecentFormSubmissions = async (forceRefresh = false, silent = false) => {
        if (app !== 'workload-forms') {
            hasFetchedFormSubmissionsRef.current = false;
            return [];
        }
        
        // Prevent duplicate calls unless forceRefresh is true
        if (!forceRefresh && (loadingFormSubmissions || hasFetchedFormSubmissionsRef.current)) {
            return recentFormSubmissions; // Return existing submissions if already fetched
        }
        
        hasFetchedFormSubmissionsRef.current = true;
        if (!silent && !loadingFormSubmissions) {
            setLoadingFormSubmissions(true);
        }
        
        try {
            // Get executions from the last 30 days
            const thirtyDaysAgo = new Date();
            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
            const timestamp = thirtyDaysAgo.toISOString();
            
            const response = await getExecutions(timestamp);
            if (response && response.data && Array.isArray(response.data)) {
                const currentNodeId = node.id;
                const formSubmissions = response.data
                    .filter(exec => exec.state && exec.state.nodes && exec.state.nodes[currentNodeId] && exec.state.nodes[currentNodeId].outputFields)
                    .map(exec => ({
                        id: exec.id || exec._id,
                        payload: exec.state.nodes[currentNodeId].outputFields,
                        date: exec.date_run || exec.created_at,
                        timestamp: exec.timestamp || new Date(exec.date_run || exec.created_at).getTime()
                    }))
                    .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0))
                    .slice(0, 10);
                
                setRecentFormSubmissions(formSubmissions);
                return formSubmissions; // Return submissions for immediate use
            } else {
                setRecentFormSubmissions([]);
                return [];
            }
        } catch (error) {
            console.error('Error fetching recent form submissions:', error);
            setRecentFormSubmissions([]);
            hasFetchedFormSubmissionsRef.current = false;
            return [];
        } finally {
            if (!silent) setLoadingFormSubmissions(false);
        }
    }

    useEffect(() => {
        let isMounted = true;
        // When opening in manual mode, node may have app but no url (e.g. AI-created node). Resolve url and hasauth from allApps.
        // Normalize built-in app URLs (webhook, schedule, workload-forms) so we always hit the correct API (7nx4ewphyg), not odkusrnpx8.
        const foundApp = app && Array.isArray(allApps) && allApps.length > 0 ? allApps.find((x) => x.app === app) : null;
        const resolvedUrl = normalizeBuiltInAppUrl(app, url) || url || (foundApp?.formDataEndpoint || null);

        // Always sync hasauth from app schema when we have a matching app, so the Account step shows when the app requires auth
        if (app && foundApp) {
            const appAuth = foundApp.auth === true;
            setHasAuth(appAuth);
            if (selectedNode?.id && node?.data && node.data.hasauth !== appAuth) {
                dispatch(elementUpdated(selectedNode.id, { ...node.data, hasauth: appAuth }, null, null));
            }
        }

        if (app && !url && foundApp) {
            setURL(foundApp.formDataEndpoint);
            if (selectedNode?.id && node?.data) {
                dispatch(elementUpdated(selectedNode.id, { ...node.data, url: foundApp.formDataEndpoint, hasauth: foundApp.auth === true }));
            }
            return;
        }

        // Persist corrected URL when node had wrong built-in app URL (e.g. webhook from agent with odkusrnpx8)
        if (app && resolvedUrl && resolvedUrl !== url && selectedNode?.id && node?.data) {
            setURL(resolvedUrl);
            dispatch(elementUpdated(selectedNode.id, { ...node.data, url: resolvedUrl }, null, null));
        }

        function getTriggers() {
            const urlToFetch = resolvedUrl || url;
            setLoadedTriggers(false);
            axios.request({
                method: "GET",
                url: urlToFetch
            }).then(res => {
                if (isMounted) {
                    setTriggers(res.data.triggers ?? []);
                    setLoadedTriggers(true);
                }
            }).catch(() => {
                if (isMounted) setLoadedTriggers(true);
            });
        }

        if (app && (resolvedUrl || url)) {
            setTriggers([]);
            getTriggers();
        } else if (app) {
            // App set but no URL (allApps not loaded or app not in list) – stop spinning
            setLoadedTriggers(true);
        }
        return () => { isMounted = false };
    }, [app, url, allApps])

    // Merge trigger schema fields with existing node field values so switching to Manual mode preserves AI/user-selected values
    const mergeTriggerFieldsWithNodeValues = (triggerFields, nodeFields) => {
        if (!Array.isArray(triggerFields) || !Array.isArray(nodeFields) || nodeFields.length === 0) return triggerFields;
        const byName = new Map((nodeFields || []).map((f) => [f?.name, f]));
        return triggerFields.map((tf) => {
            const existing = byName.get(tf?.name);
            if (!existing) return tf;
            return { ...tf, value: existing.value };
        });
    };

    useEffect(() => {
        
        let isMounted = true;
        if (Object.keys(triggers).length > 0 && isMounted && trigger && trigger.key) {
            const triggerData = triggers[trigger.key];
            if (triggerData) {
                // Load fields from trigger data when trigger changes
                // This is the primary way fields are loaded for triggers
                if (triggerData.fields) {
                    // Preserve existing node field values when opening Manual mode (e.g. from read-only); don't overwrite with schema-only
                    const nodeFields = node?.data?.fields;
                    const merged = (nodeFields && Array.isArray(nodeFields) && nodeFields.length > 0)
                        ? mergeTriggerFieldsWithNodeValues(triggerData.fields, nodeFields)
                        : triggerData.fields;
                    setFields(merged);
                }
                // Set type if available (polling, webhook, etc.)
                if (triggerData.type) {
                    setType(triggerData.type);
                }
                // CRITICAL: Set performList and triggerResource from trigger data's 'action' property
                // API shape: trigger key (e.g. webhookReceived) has .action (e.g. createWebhook).
                // Polling: performList and triggerResource = trigger's .action (e.g. listCardsOnBoard).
                // Webhook: triggerResource = trigger's .action (createWebhook); performList stays empty.
                if (triggerData.action) {
                    const triggerAction = triggerData.action;
                    if (type === 'polling') {
                        if (!performList || performList === trigger.key || performList !== triggerAction) {
                            setPerformList(triggerAction);
                            if (node?.data && (!node.data.triggerResource || node.data.triggerResource === trigger.key || node.data.triggerResource !== triggerAction)) {
                                dispatch(elementUpdated(selectedNode.id, {
                                    ...node.data,
                                    triggerResource: triggerAction,
                                    performList: triggerAction
                                }, null, null));
                            }
                        }
                    } else if (app === BUILT_IN_TRIGGER_APPS.WEBHOOK && node?.data && (!node.data.triggerResource || node.data.triggerResource !== triggerAction)) {
                        dispatch(elementUpdated(selectedNode.id, {
                            ...node.data,
                            triggerResource: triggerAction
                        }, null, null));
                    }
                }
                // Set pollingParams from trigger data if available
                if (triggerData.pollingParams) {
                    setPollingParams(triggerData.pollingParams);
                }
            }
        }
        return () => { isMounted = false };
    }, [trigger, triggers, type, performList, app])

    // useEffect(() => {
    // }, [schemaForm])
    
    const setNodeNameAuto = (newApp, newAction) => {
        if (name == 'Add trigger') {
            setName((newAction ? (newAction + ' in ' + newApp) : ""));
        } else if (name == label) {
            setName((newAction ? (newAction + ' in ' + newApp) : ""));
        } else if (!name) {
            setName((newAction ? (newAction + ' in ' + newApp) : ""));
        } else if (name == (label + ' - ' + trigger.label)) {
            setName((newAction ? (newAction + ' in ' + newApp) : ""));
        } else {
            setName((newAction ? (newAction + ' in ' + newApp) : ""));
        }
    }

    const sendAlert = () => {
        dispatch(alertName({ "severity": "success", "message": node.data.name + " saved successfully" }))
    }

    const sendTriggerData = (data) => {
        mixpanel.track('Trigger Select', {
            'trigger': data
        });
    }

    const sendTriggerEventData = (data, event) => {
        mixpanel.track('Trigger Event Selected', {
            'app': data,
            'event': event
        });
    }

    const handleSaveClick = () => {
        dispatch(saveWorkflow(1))
    }

    const resetForm = () => {
        setStep(activeStep - 1)
        setTestData(null);
    }

    const classes = useStyles();


    const handleTriggerClick = (event) => {
        //sendTrigger(event);

        // Set flag to prevent sync useEffect from interfering
        isManualSaveRef.current = true;

        if (event === 'schedule') {
            const newApp = 'schedule';
            const newLabel = 'Schedule';
            const newURL = "https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/apps/schedule";
            const newIcon = "https://cms.workload.co/wp-content/uploads/2021/07/schedule.svg";
            const newHasAuth = false;
            
            setApp(newApp);
            setLabel(newLabel);
            setURL(newURL);
            setIcon(newIcon);
            iconErrorRef.current = false; // Reset icon error when setting new icon
            setHasAuth(newHasAuth);
            
            // Save immediately with new values
            setTimeout(() => {
                saveNode('changed app');
                setStep(1);
                // Clear flag after save completes
                setTimeout(() => {
                    isManualSaveRef.current = false;
                }, 100);
            }, 0);
        }
        else if (event === 'webhook') {
            const newApp = 'webhook';
            const newLabel = 'Webhook';
            const newURL = "https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/apps/webhook";
            const newIcon = "https://cdn.workload.co/wp-content/uploads/2021/09/webhook-1.png";
            const newHasAuth = false;
            
            setApp(newApp);
            setLabel(newLabel);
            setURL(newURL);
            setIcon(newIcon);
            iconErrorRef.current = false; // Reset icon error when setting new icon
            setHasAuth(newHasAuth);
            setType('webhook');
            
            // Save immediately with new values
            setTimeout(() => {
                saveNode('changed app');
                setStep(1);
                // Clear flag after save completes
                setTimeout(() => {
                    isManualSaveRef.current = false;
                }, 100);
            }, 0);
        }
        else if (event === 'workload-forms') {
            const newApp = 'workload-forms';
            const newLabel = 'Forms by Workload';
            const newURL = "https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/apps/workload-forms";
            const newIcon = "https://cms.workload.co/wp-content/uploads/workload-forms.png";
            const newHasAuth = false;
            
            setApp(newApp);
            setLabel(newLabel);
            setURL(newURL);
            setIcon(newIcon);
            iconErrorRef.current = false; // Reset icon error when setting new icon
            setHasAuth(newHasAuth);
            
            // Save immediately with new values
            setTimeout(() => {
                saveNode('changed app');
                setStep(1);
                // Clear flag after save completes
                setTimeout(() => {
                    isManualSaveRef.current = false;
                }, 100);
            }, 0);
        }

    }
    function sleep(delay = 0) {
        return new Promise((resolve) => {
            setTimeout(resolve, delay);
        });
    }

    const [appopen, setAppOpen] = useState(false);
    const [appoptions, setAppOptions] = useState([]);
    const [apploading, setAppLoading] = useState()
    useEffect(() => {
        let active = true;

        if (!apploading) {
            return undefined;

        }

        (async () => {
            const response = allApps;
            await sleep(2e3); // For demo purposes.
            const apps = await response;
            if (active) {
                setAppOptions(Object.keys(apps).map((key) => apps[key]));
                setAppLoading(false)
            }
        })();

        return () => {
            active = false;
        };
    }, [apploading]);
    useEffect(() => {
        
        if (!appopen) {
            setAppOptions([]);
            setAppLoading(true);
        }
    }, [appopen]);

    // Fuzzy matching function for app search
    const fuzzyMatch = (searchText, appText) => {
        if (!searchText || !appText) return false;
        
        // Normalize both strings: lowercase, remove spaces and special characters
        const normalize = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
        const normalizedSearch = normalize(searchText);
        const normalizedApp = normalize(appText);
        
        // If normalized search is empty after normalization, don't match
        if (!normalizedSearch) return false;
        
        // Exact substring match (highest priority)
        if (normalizedApp.includes(normalizedSearch)) return true;
        
        // Check if all characters in search appear in order in app name (character sequence matching)
        // This handles cases like "smrt" matching "smart"
        let searchIndex = 0;
        let firstMatchIndex = -1;
        let lastMatchIndex = -1;
        for (let i = 0; i < normalizedApp.length && searchIndex < normalizedSearch.length; i++) {
            if (normalizedApp[i] === normalizedSearch[searchIndex]) {
                if (firstMatchIndex === -1) {
                    firstMatchIndex = i;
                }
                lastMatchIndex = i;
                searchIndex++;
            }
        }
        // If all characters matched in order, it's a fuzzy match
        if (searchIndex === normalizedSearch.length) {
            const matchSpan = lastMatchIndex - firstMatchIndex + 1;
            
            // Check if app name starts with the search prefix (e.g., "smartemailing" starts with "sma" from "smrt")
            // This is a strong signal that it's a match
            const prefixLength = Math.min(3, normalizedSearch.length);
            const searchPrefix = normalizedSearch.substring(0, prefixLength);
            if (normalizedApp.startsWith(searchPrefix)) {
                // Allow matches that start with the prefix, but still limit the span
                // For "smrt" matching "smartemailing": s(0), m(1), r(2), t(4) -> span is 5
                return matchSpan <= normalizedSearch.length * 2 + 2; // Allow span up to 2x search length + 2
            }
            
            // For matches that don't start with the prefix, be much stricter
            // Only allow if characters are very close together (within 1.5x search length)
            // This catches cases like "smrt" -> "smart" but not "smrt" -> "samcart" (span too long)
            return matchSpan <= normalizedSearch.length * 1.5 + 1;
        }
        
        // Levenshtein distance check for very close matches (only for small differences)
        // Only use this if search and app are similar in length
        if (Math.abs(normalizedSearch.length - normalizedApp.length) <= 2) {
            const levenshteinDistance = (str1, str2) => {
                const matrix = [];
                for (let i = 0; i <= str2.length; i++) {
                    matrix[i] = [i];
                }
                for (let j = 0; j <= str1.length; j++) {
                    matrix[0][j] = j;
                }
                for (let i = 1; i <= str2.length; i++) {
                    for (let j = 1; j <= str1.length; j++) {
                        if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
                            matrix[i][j] = matrix[i - 1][j - 1];
                        } else {
                            matrix[i][j] = Math.min(
                                matrix[i - 1][j - 1] + 1,
                                matrix[i][j - 1] + 1,
                                matrix[i - 1][j] + 1
                            );
                        }
                    }
                }
                return matrix[str2.length][str1.length];
            };
            
            const distance = levenshteinDistance(normalizedSearch, normalizedApp);
            const minLength = Math.min(normalizedSearch.length, normalizedApp.length);
            
            // Only accept if distance is very small relative to the shorter string (max 1-2 char difference)
            // and the shorter string is at least 3 characters (to avoid matching very short strings)
            if (minLength >= 3 && distance <= 2 && distance <= Math.floor(minLength * 0.4)) {
                return true;
            }
        }
        
        return false;
    };

    const allAppsFilterOptions = (options, state) => {
        // Material-UI Autocomplete passes { inputValue, getOptionLabel } as state
        const inputValue = state?.inputValue || '';
        
        if (!inputValue || !inputValue.trim()) {
            return options.slice(0, 50);
        }
        
        const normalizedInput = inputValue.toLowerCase().trim();
        
        // Filter using fuzzy matching
        const filtered = options.filter((option) => {
            const appName = (option.name || '').trim();
            const appTitle = (option.title || '').trim();
            const appCategory = (option.category || '').trim();
            
            // Only check fuzzy match if we have actual text to search
            if (!appName && !appTitle && !appCategory) {
                return false;
            }
            
            // Check fuzzy match against name, title, and category
            return fuzzyMatch(inputValue, appName) || 
                   fuzzyMatch(inputValue, appTitle) || 
                   fuzzyMatch(inputValue, appCategory);
        });
        
        // Sort by relevance: exact matches first, then fuzzy matches
        const sorted = filtered.sort((a, b) => {
            const aName = (a.name || '').toLowerCase();
            const bName = (b.name || '').toLowerCase();
            const searchLower = normalizedInput;
            
            // Prioritize exact substring matches
            const aExact = aName.includes(searchLower);
            const bExact = bName.includes(searchLower);
            if (aExact && !bExact) return -1;
            if (!aExact && bExact) return 1;
            
            // Then prioritize matches that start with search
            const aStartsWith = aName.startsWith(searchLower);
            const bStartsWith = bName.startsWith(searchLower);
            if (aStartsWith && !bStartsWith) return -1;
            if (!aStartsWith && bStartsWith) return 1;
            
            // Then alphabetical
            return aName.localeCompare(bName);
        });
        
        return sorted.slice(0, 50);
    }

    const filter = createFilterOptions();

    // const [activeStep, setStep] = useState((testData) ? ((trigger && (!hasauth || (hasauth && authname))) ? (4) : (3)) : (trigger ? 2 : (app ? 1 : 0)));
    const [activeStep, setStep] = useState(0)
    const hasDynamicForm = trigger && Object.keys(triggers).length > 0 && triggers[trigger]?.dynamicForm
    const finalStep = (hasauth ? hasDynamicForm ? 99 : 99 : 99)
    const testStep = useMemo(() => hasauth ? hasDynamicForm ? 4 : 3 : 2, [hasauth, hasDynamicForm])
   
    const [triggerError, setTriggerError] = useState()
    // Canvas centering is handled by flowApp fitView so all panel views stay consistent (Agent / ReadOnly / Advanced)

    const handleSetUpTrigger = () => {
        setStep(activeStep + 1); saveNode()
    }

    const handlePerformList = (n) => {
        saveNode()
        handleSaveClick()
        setLoadingChoices(true); // Set loading state while fetching
        dispatch(fetchTriggerChoices({ skip: 0, limit: 5, append: false })).then((response) => {
            setLoadingChoices(false); // Clear loading state
            if (response.error) {
                setTriggerError(response)
                setStep(88)
                saveNode()
            } else {
                // Check if no choices were returned
                const choices = response.payload?.triggerChoices || []
                if (choices.length === 0) {
                    // No choices found - this will be handled in the UI
                    // The empty state message will be shown
                }
            }
        });
        // Set step to testStep (99) to show awaiting state while fetching
        setStep(99);
    }
    const delay = ms => new Promise(res => setTimeout(res, ms));
    const [loadingchoices, setLoadingChoices] = useState(false)
    const handleLoadMorePerformList = async (event) => {
        setLoadingChoices(true)
        event.stopPropagation()
        
        // Get current number of choices from Redux node data to determine skip value
        // Use node.data.triggerChoices to ensure we have the latest count from Redux
        const currentChoicesCount = (node?.data?.triggerChoices && Array.isArray(node.data.triggerChoices)) 
            ? node.data.triggerChoices.length 
            : 0
        
        // Fetch next batch of choices (skip current count, limit 5, append to existing)
        dispatch(fetchTriggerChoices({ skip: currentChoicesCount, limit: 5, append: true })).then((response) => {
            setLoadingChoices(false)
            if (response.error) {
                setTriggerError(response)
                setStep(88)
                saveNode()
                setLoadingChoices(false)
            } else {
                // Update triggerChoiceTime to reflect fresh fetch
                setTriggerChoiceTime(Date.now())
                
                // Auto-select the first new choice from the response payload
                // response.payload.triggerChoices contains the new batch that was just fetched
                const newChoices = response.payload?.triggerChoices || []
                
                if (newChoices.length > 0) {
                    // Get the first new choice
                    const firstNewChoice = newChoices[0]
                    // The index in the full array is currentChoicesCount (where the new batch starts)
                    const firstNewChoiceIndex = currentChoicesCount
                    
                    if (firstNewChoice) {
                        // Set flag to prevent sync useEffect from interfering
                        isManualSaveRef.current = true
                        
                        // Auto-select the first new choice
                        setChoiceTestData(firstNewChoice, firstNewChoiceIndex)
                        // triggerChoiceTime is already set above, but ensure it's saved with the choice
                        
                        // Save the node with the auto-selected choice
                        setTimeout(() => {
                            saveNode()
                            // Clear flag after save completes
                            setTimeout(() => {
                                isManualSaveRef.current = false
                            }, 100)
                        }, 0)
                    }
                } else {
                    // No new choices returned from "Load More" - show a brief notification
                    // The user will see that no more items are available
                    dispatch(notification({ "status": "info", "message": "No more " + triggerlabel.toLowerCase() + " found" }))
                }
            }
        });
       
        
    }

    const handleSetUpTriggerTest = () => {
        if (performList) {
            handlePerformList();
        } else {
        saveNode()
        handleSaveClick()
        if (triggerMessage) {
            setStep(activeStep + 1);
        } else {
            // For schedule and other triggers, create trigger to get triggerMessage
            dispatch(createTrigger(workflowID)).then((response) => {
                if (response.error) {
                    setTriggerError(response)
                    setStep(88)
                    saveNode()
                } else if (response.payload && response.payload.triggerMessage) {
                    // Set the triggerMessage which contains the schedule/trigger data
                    const message = response.payload.triggerMessage;
                    setTriggerMessage(message);
                    // Also update Redux node to persist the triggerMessage
                    dispatch(elementUpdated(selectedNode.id, {
                        ...node.data,
                        triggerMessage: message
                    }, null, null));
                    // Update refs to prevent sync useEffect from overwriting
                    prevFieldsRef.current = fields;
                    prevNodeStateRef.current = { name, app, label, icon, hasauth, trigger, credentialId, authname };
                }
            });
        }
        setStep(activeStep + 1);
    }

    }

    useEffect(() => {
        if (type === 'polling' && triggerMessage) {
            // document.getElementById("polling-button").click()
        }
        if (app !== 'schedule' && app !== 'webhook' && type === 'webhook' && triggerMessage) {
            // document.getElementById("webhook-button").click()
            setAwaitingTrigger(true)
        }
        // For schedule triggers, automatically set testData when triggerMessage is set
        if (app === 'schedule' && triggerMessage && !testData) {
            setTestData(triggerMessage);
            setChoice(triggerlabel + " " + 1);
            setStep(99);
            saveNode();
            dispatch(saveWorkflow(1));
        }
        // For webhook triggers, if triggerMessage is set, we're ready to show the webhook URL
        // Don't auto-advance to Test step - let user click Continue button
    }, [triggerMessage, type, app, testData, triggerlabel])
    
    // Auto-select first trigger choice when triggerChoices are populated (for polling and schedule triggers)
    // Auto-select first webhook payload when recentWebhookPayloads are populated (for webhook triggers)
    useEffect(() => {
        // For polling and schedule triggers: auto-select first trigger choice
        if ((type === 'polling' || app === 'schedule') && triggerChoices && Array.isArray(triggerChoices) && triggerChoices.length > 0) {
            // Check if we need to auto-select (no triggerchoice set or testData is empty)
            // Also check if we haven't already auto-selected for this set of triggerChoices
            if ((!triggerchoice || triggerchoice === '' || !testData || testData === '') && !hasAutoSelectedRef.current) {
                // Auto-select the first trigger choice (index 0)
                const firstChoice = triggerChoices[0];
                if (firstChoice) {
                    hasAutoSelectedRef.current = true; // Mark as auto-selected
                    setTestData(firstChoice);
                    setChoice(triggerlabel + " 1");
                    setTriggerChoiceTime(Date.now());
                    // Save the node with the auto-selected choice
                    setTimeout(() => {
                        saveNode();
                    }, 0);
                }
            }
        } 
        else if (app !== 'webhook' && type === 'webhook' && triggerChoices && Array.isArray(triggerChoices) && triggerChoices.length > 0) {
            // Check if we need to auto-select (no triggerchoice set or testData is empty)
            // Also check if we haven't already auto-selected for this set of triggerChoices
            if ((!triggerchoice || triggerchoice === '' || !testData || testData === '') && !hasAutoSelectedRef.current) {
                // Auto-select the first trigger choice (index 0)
                const firstChoice = triggerChoices[0];
                if (firstChoice) {
                    hasAutoSelectedRef.current = true; // Mark as auto-selected
                    setTestData(firstChoice);
                    setChoice(triggerlabel + " 1");
                    setTriggerChoiceTime(Date.now());
                    // Save the node with the auto-selected choice
                    setTimeout(() => {
                        saveNode();
                    }, 0);
                }
            }
        }
        else if (!triggerChoices || !Array.isArray(triggerChoices) || triggerChoices.length === 0) {
            // Reset the flag when triggerChoices are cleared
            hasAutoSelectedRef.current = false;
        }
        
        // For webhook triggers: auto-select first recent payload
        if (app === 'webhook' && type === 'webhook' && recentWebhookPayloads && Array.isArray(recentWebhookPayloads) && recentWebhookPayloads.length > 0) {
            // Check if we need to auto-select (no triggerchoice set or testData is empty)
            // Also check if we haven't already auto-selected for this set of payloads
            if ((!triggerchoice || triggerchoice === '' || !testData || testData === '') && !hasAutoSelectedRef.current) {
                // Auto-select the first payload (index 0)
                const firstPayload = recentWebhookPayloads[0];
                if (firstPayload && firstPayload.payload) {
                    hasAutoSelectedRef.current = true; // Mark as auto-selected
                    setTestData(firstPayload.payload);
                    setChoice(triggerlabel + " 1"); // Match the format used in MenuItem values
                    setTriggerChoiceTime(firstPayload.timestamp || Date.now());
                    // Save the node with the auto-selected payload
                    setTimeout(() => {
                        saveNode();
                    }, 0);
                }
            }
        } else if (app === 'webhook' && type === 'webhook' && (!recentWebhookPayloads || !Array.isArray(recentWebhookPayloads) || recentWebhookPayloads.length === 0)) {
            // Reset the flag when recentWebhookPayloads are cleared
            hasAutoSelectedRef.current = false;
        }
        
        // For workload-forms triggers: auto-select first recent form submission
        if (app === 'workload-forms' && recentFormSubmissions && Array.isArray(recentFormSubmissions) && recentFormSubmissions.length > 0) {
            // Check if we need to auto-select (no triggerchoice set or testData is empty)
            // Also check if we haven't already auto-selected for this set of submissions
            if ((!triggerchoice || triggerchoice === '' || !testData || testData === '') && !hasAutoSelectedRef.current) {
                // Auto-select the first submission (index 0)
                const firstSubmission = recentFormSubmissions[0];
                if (firstSubmission && firstSubmission.payload) {
                    hasAutoSelectedRef.current = true; // Mark as auto-selected
                    setTestData(firstSubmission.payload);
                    setChoice(triggerlabel + " 1"); // Match the format used in MenuItem values
                    setTriggerChoiceTime(firstSubmission.timestamp || Date.now());
                    // Save the node with the auto-selected submission
                    setTimeout(() => {
                        saveNode();
                    }, 0);
                }
            }
        } else if (app === 'workload-forms' && (!recentFormSubmissions || !Array.isArray(recentFormSubmissions) || recentFormSubmissions.length === 0)) {
            // Reset the flag when recentFormSubmissions are cleared
            hasAutoSelectedRef.current = false;
        }
    }, [triggerChoices, type, triggerchoice, testData, triggerlabel, app, recentWebhookPayloads, recentFormSubmissions])

    // For built-in webhook/workload-forms triggers: ensure createTrigger runs when panel opens with
    // trigger already set but no triggerMessage (e.g. manual mode, AI-configured node, or reopening panel).
    // Normally triggerMessage is set in the Event step Autocomplete onChange; if the user didn't change
    // the selection (e.g. trigger was pre-set), that path never runs and triggerMessage stays empty.
    const hasTriedCreateTriggerRef = useRef(false);
    useEffect(() => {
        const needsTriggerMessage = ((app === BUILT_IN_TRIGGER_APPS.WEBHOOK && type === 'webhook') || app === BUILT_IN_TRIGGER_APPS.WORKLOAD_FORMS) &&
            trigger?.key && !triggerMessage && !creatingWebhookTrigger;
        if (!needsTriggerMessage) {
            if (triggerMessage) hasTriedCreateTriggerRef.current = false;
            return;
        }
        if (hasTriedCreateTriggerRef.current) return;
        hasTriedCreateTriggerRef.current = true;
        setCreatingWebhookTrigger(true);
        dispatch(saveWorkflow(1))
            .then(() => dispatch(createTrigger(workflowID)))
            .then((response) => {
                if (response.payload && response.payload.triggerMessage) {
                    const message = response.payload.triggerMessage;
                    setTriggerMessage(message);
                    dispatch(elementUpdated(selectedNode.id, {
                        ...node.data,
                        triggerMessage: message
                    }, null, null));
                    prevFieldsRef.current = fields;
                    prevNodeStateRef.current = { name, app, label, icon, hasauth, trigger, credentialId, authname };
                    saveNode('changed event');
                }
            })
            .catch((error) => {
                console.error('Error creating trigger (webhook/workload-forms):', error);
                hasTriedCreateTriggerRef.current = false;
            })
            .finally(() => {
                setCreatingWebhookTrigger(false);
            });
    }, [app, type, trigger?.key, triggerMessage, creatingWebhookTrigger, workflowID, selectedNode?.id, node?.data, dispatch, fields, trigger, name, label, icon, hasauth, credentialId, authname]);

    // While listening for webhook/workload-forms: poll for new payloads (silent = no loading UI); when one arrives, deactivate and stop.
    const isListeningForPayload = awaitingTrigger && ((app === BUILT_IN_TRIGGER_APPS.WEBHOOK && type === 'webhook') || app === BUILT_IN_TRIGGER_APPS.WORKLOAD_FORMS);
    useEffect(() => {
        if (!isListeningForPayload || !workflowID) return;
        const POLL_MS = 2500;
        const interval = setInterval(async () => {
            let payloads = [];
            if (app === BUILT_IN_TRIGGER_APPS.WEBHOOK && type === 'webhook') {
                payloads = await fetchRecentWebhookPayloads(true, true); // forceRefresh, silent (no loading state)
            } else if (app === BUILT_IN_TRIGGER_APPS.WORKLOAD_FORMS) {
                payloads = await fetchRecentFormSubmissions(true, true);
            }
            if (Array.isArray(payloads) && payloads.length > 0) {
                setAwaitingTrigger(false);
                dispatch(activeUpdated(false));
                dispatch(saveWorkflow(1));
            }
        }, POLL_MS);
        return () => clearInterval(interval);
    }, [isListeningForPayload, workflowID, app, type]);

    // Fetch recent webhook payloads - only called manually when needed
    // Removed auto-fetch from useEffect to prevent infinite loops
    
   const handleModalOpen = () => {
    setModalOpen(true)
   }

   const handleModalClose = () => {
    setModalOpen(false)
   }

    const handleNextNodeOpen = () => {
        var obj = workflow[node.id].connections
        let [firstKey] = Object.keys(obj)
        dispatch(elementSelected(firstKey))
    }

    const modalbody = (
        <div style={modalStyle} className={classes.modalstyle}>
         <DialogTitle style={{ paddingBottom: '12px', textAlign: 'center' }}>
           <Typography style={{fontSize: '20px', fontWeight: 600, color: 'black', marginBottom: '8px'}}>
             Coming Soon!
           </Typography>
           <Typography style={{fontSize: '16px', fontWeight: 500, color: '#666'}}>
             AI-Powered Trigger Creation
           </Typography>
         </DialogTitle>
         <DialogContent style={{ padding: '16px 24px' }}>
        <DialogContentText>
          <div style={{ textAlign: 'center', padding: '8px 0' }}>
            <Typography style={{fontSize: '14px', color: '#666', lineHeight: '1.5'}}>
              We're working on an AI-powered feature that will help you create custom triggers quickly and easily. 
              This feature will be available soon.
            </Typography>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center', padding: '8px 16px 16px' }}>
        <Button onClick={handleModalClose} variant="contained" color="primary" style={{textTransform: 'none', minWidth: '100px'}}>
          Got it
        </Button>
      </DialogActions>
        </div>
      );
    

 /*    useEffect(() => {
        // 👇️ scroll to bottom every time messages change
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [triggerMessage, testData]); */

    const [timeLeft, setTimeLeft] = useState(61);
  

    

    useEffect(() => {
      
       

       
        // exit early when we reach 0
        if (timeLeft === 0 || 61 && awaitingTrigger === false) return;

        // save intervalId to clear the interval when the
        // component re-renders
        // var executionLength = executions.length;
        //var timestamp = new Date();
       
        const interval = setInterval(() => {
            setTimeLeft(timeLeft- 1);
            getExecutions(timestamp).then(resp => {
                setExecutions(resp.data);
            
                if (resp.data.length > 0) {
                    setTestData(resp.data[0].state.nodes[node.id].outputFields)
                    setAwaitingTrigger(false)
                    dispatch(activeUpdated(false))
                    dispatch(saveWorkflow(1))
                    handleSaveClick();
                    setTimeLeft(61)
                    clearInterval(interval)

                }
                if (timeLeft === 1) {

                    setAwaitingTrigger(false)
                    dispatch(activeUpdated(false))
                    dispatch(saveWorkflow(1))
                    handleSaveClick();
                    setTimeLeft(61)
                    clearInterval(interval)
                    setStep(testStep)

                }
            })

        }, 1000);

        // clear interval on re-render to avoid memory leaks
        return () => { clearInterval(interval);
        };
        // add timeLeft as a dependency to re-rerun the effect
        // when we update it
        
        // hook into awaitingTrigger instead of timeLeft
    }, [timeLeft]);

    

   /*  useEffect(() => {
    }, [activeStep]) */
    
    const [anchorElPop, setAnchorElPop] = React.useState(null);
    const handlePopClick = (event) => {
        setAnchorElPop(anchorElPop ? null : event.currentTarget);
    };
    const handlePopClose = (event) => {
        
        setAnchorElPop(null);
    };
    const openpop = Boolean(anchorElPop);
    const id = openpop ? 'simple-popper' : undefined;
    const [poptext, setPopText] = React.useState();

    const [plan, setPlan] = useState();
    const [planStatus, setPlanStatus] = useState()
    const getTenantPlan = () => {
        var token = localStorage.getItem('tok_')
        axios({
          method: 'get',
          url: 'https://backend.workload.co/api/tenant/'+tenant,
          headers: {
            'Authorization': 'Bearer '+token,
            'Content-Type': 'application/json'
          }
        })
      }

      useEffect(() => {
        
        getTenantPlan() 
      }, [])

      const setChoiceTestData = (data, choice) => {
        setTestData(data)
        var number = choice + 1
        setChoice(triggerlabel +" "+number)
      }

      const triggeroptions = triggers ? 
      Object.entries(triggers).map(([k, v]) => {
                                             
        return {
            key: k,
            label: v.label ?? k ?? "",
            pollingParams: v.pollingParams,
            description: v.description ?? "",
            performList: v.performList,
            unsubscribe: v.unsubscribe,
            webhookKey: v.webhookKey
        }
    }) : []

    const PaperComponentCustom = options => {
        const { containerProps, children } = options;
        return (
            <Paper {...containerProps} style={{ fontWeight: 600, padding: 4, backgroundColor: theme.palette.background.paper }}>
             {children}
                { hasauth === false ? null : <>
                <div>
                    <br />
                    <Divider /><br />

                  <Typography variant='body2' align='center' style={{color: 'gray'}}>Can't find the <span style={{ padding: 4, alignItems: 'baseline', fontWeight: 300, fontSize: '16px', border: '1px solid gray', borderRadius: '4px' }}><div style={{ display: 'inline-flex', alignItems: 'flex-end', marginLeft: '0px', marginTop: '4px', padding: '0px 0px 0px 0px' }} ><img src={icon} style={{ height: '25px', width: '25px', marginBottom: '-6px', paddingRight: '4px', position: 'absolute' }} /></div><div style={{ display: 'inline-flex', marginLeft: '29px' }}>{label}</div></span> trigger you're searching for?</Typography><br />
                </div>
               
                <div style={{ justifyContent: 'center', display: 'flex' }}>
                    <Button variant='contained'
                        style={{ textTransform: 'none', backgroundColor: 'black', color: 'white', fontWeight: 600, marginBottom: '10px' }}
                        onMouseDown={() => {
                            handleModalOpen()
                        }}
                    >
                        + Create a new trigger
                    </Button> 

</div></>
    }

            </Paper>
        );
    };

    const panelWrapStyle = inlineLayout ? { position: 'relative', width: '100%', height: '100%', minHeight: 0, overflow: 'auto', paddingLeft: 6, paddingRight: 12 } : {};
    const panelClassName = inlineLayout ? undefined : notrigger.Panel;
    const mainPanelClassName = inlineLayout ? undefined : styles.Panel;
    try {
        return (
            !app ? <div className={panelClassName} style={panelWrapStyle}>
            <div id='trigger-empty' className={classes.cardblack}>

                <div id='new-trigger-banner' style={{ width: '100%', height: '70px', backgroundColor: '#0069ea' }}>
                    <Avatar style={{ display: 'flex', float: 'left', marginTop: '20px', marginLeft: '10px' }}>
                        <BoltRoundedIcon style={{ color: 'blue', width: 40, height: 40 }} />
                    </Avatar>
                    <div style={{ display: 'block', float: 'left', marginLeft: '10px' }}>
                        <Typography style={{ color: 'white', marginTop: '0px' }} ><h4>1. Trigger</h4></Typography>
                        <Typography style={{ fontSize: '13px', color: 'white', marginTop: '-25px' }}>Triggers are events that start your workflow</Typography>

                    </div>
                </div>
                <Grid container spacing={0}>
                    <Grid item xs={breakpoint !== 'large' ? 12 : 8}>
                        <Paper className={classes.papermain}>
                            <Avatar style={{ width: 30, height: 30, display: 'flex', float: 'left', marginTop: '20px', marginLeft: '0px', marginRight: '5px' }}>
                                <AppsIcon style={{ width: 20, height: 20 }} />
                            </Avatar>
                            <Typography style={{ fontSize: '13px', marginTop: '18px', fontWeight: 'bold' }} >Trigger App</Typography>
                            <Typography style={{ fontSize: '11px', marginTop: '-2px' }} >Start your workflow when something happens in a specific app.</Typography>
                            <Autocomplete
                                style={{ width: '100%', height: '60px' }}

                                autoComplete
                                id="trigger-combo-box-demo"
                                className={classes.selectInput}
                                options={allApps}
                                value={label}
                                open={appopen}
                                filterOptions={allAppsFilterOptions}
                                onOpen={() => {
                                    setAppOpen(true);
                                }}
                                onClose={() => {
                                    setAppOpen(false);
                                }}
                                loading={apploading}
                                loadingText={"Loading Triggers..."}
                                noOptionsText={"Request a new trigger via chat (bottom right)"}
                                getOptionLabel={(option) => option.name ?? label}

                                onChange={(e, v) => {
                                    if (v === null) {
                                        v = "";
                                    } else {
                                        // Set flag to prevent sync useEffect from interfering
                                        isManualSaveRef.current = true;
                                        
                                        // Clear all related state when app changes
                                        setCredentialId(null);
                                        setAuthname(null);
                                        setTrigger({ key: '', label: '' });
                                        setTriggerMessage('');
                                        setTriggerChoices('');
                                        setChoice('');
                                        setTestData('');
                                        
                                        // Update app-related state
                                        setNodeNameAuto(v.name, undefined);
                                        setApp(v.app);
                                        setCustomButton(v.custombutton);
                                        sendTriggerData(v.app);
                                        setIcon(v.icon);
                                        setHasAuth(v.auth);
                                        setLabel(v.name);
                                        setURL(v.formDataEndpoint);
                                        
                                        // Track app selected
                                        trackAppSelected(v.name, v.app, 'trigger');
                                        
                                        // Save the changes with description after state updates
                                        setTimeout(() => {
                                            saveNode('changed app');
                                            setStep(1);
                                            // Clear flag after save completes
                                            setTimeout(() => {
                                                isManualSaveRef.current = false;
                                            }, 100);
                                        }, 0);
                                        
                                        // Save to recent apps
                                        saveRecentApp(v, 'trigger');
                                        setRecentAppsUpdated(Date.now());
                                    }
                                }}
                                renderOption={(option) => (
                                    <MenuItem style={{ width: '100%' }}>
                                        <span>
                                            <Avatar style={{ padding: breakpoint !== 'large' ? '1px' : '4px', width: breakpoint !== 'large' ? '24px' : '32px', height: breakpoint !== 'large' ? '24px' : '32px', marginRight: '10px' }} src={option.icon} />
                                        </span>
                                        {option.name}
                                    </MenuItem>
                                )}
                                renderInput={(params) => (
                                    <div style={{ position: "relative", width: '85%', marginTop: '30px' }}>
                                        {params.inputProps.value && (

                                            <span>
                                                {/* Write logic to have Icon from params.inputProps.value */}
                                                {<Avatar style={{
                                                    position: "absolute",
                                                    transform: "translateY(40%)",
                                                    marginLeft: "10px",
                                                    width: '32px', height: '32px', marginRight: '30px'
                                                }} src={icon} />}
                                            </span>
                                        )}
                                        <TextField
                                            autoFocus={true}
                                            {...params}
                                            label="Search for an App"
                                            variant="outlined"
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: "off",
                                                style: { paddingLeft: "45px" } // disable autocomplete and autofill
                                            }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {allApps.length === 0 ? <CircularProgress style={{ marginRight: 20 }} color={colors[color]} size={30} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                )

                                            }}
                                        />
                                    </div>
                                )}
                            />
                            <FormHelperText>Type the name of the app that you want to connect to.</FormHelperText><br />

                            { /* <Avatar style={{width: 30, height: 30, float: 'left', marginTop: '10px', marginLeft: '0px', marginRight: '5px'}} label={data.name} src="https://cdn.workload.co/wp-content/uploads/todoist.png" alt={data.name}>
          <AppsIcon style={ {width : 20,height:20 } }  />
          </Avatar>
          <Avatar style={{width: 30, height: 30,float: 'left', marginTop: '10px', marginLeft: '0px', marginRight: '5px'}} label={data.name} src="https://cdn.workload.co/wp-content/uploads/2021/07/clio-1.png" alt={data.name}>
          <AppsIcon style={ {width : 20,height:20 } }  />
          </Avatar>
          <Avatar style={{width: 30, height: 30, float: 'left', marginTop: '10px', marginLeft: '0px', marginRight: '5px'}} label={data.name} src="https://cdn.workload.co/wp-content/uploads/2021/07/stripe.png" alt={data.name}>
          <AppsIcon style={ {width : 20,height:20 } }  />
          </Avatar>
          <Avatar style={{width: 30, height: 30, float: 'left', marginTop: '10px', marginLeft: '0px', marginRight: '5px'}} label={data.name} src="https://cdn.workload.co/wp-content/uploads/2021/11/clickup.png" alt={data.name}>
          <AppsIcon style={ {width : 20,height:20 } }  />
          </Avatar>
          <Avatar style={{width: 30, height: 30,float: 'left', marginTop: '10px', marginLeft: '0px', marginRight: '5px'}} label={data.name} src="https://cdn.workload.co/wp-content/uploads/lever.png" alt={data.name}>
          <AppsIcon style={ {width : 20,height:20 } }  />
          </Avatar>
          <Avatar style={{width: 30, height: 30, float: 'left', marginTop: '10px', marginLeft: '0px', marginRight: '5px'}} label={data.name} src="https://cdn.workload.co/wp-content/uploads/2020/12/Google-Sheets-logo.png" alt={data.name}>
          <AppsIcon style={ {width : 20,height:20 } }  />
          </Avatar>
          <Avatar style={{width: 30, height: 30, float: 'left', marginTop: '10px', marginLeft: '0px', marginRight: '5px'}} label={data.name} src="https://cdn.workload.co/wp-content/uploads/2020/12/airtable-logo-1.png" alt={data.name}>
          <AppsIcon style={ {width : 20,height:20 } }  />
          </Avatar>
          <Avatar style={{width: 30, height: 30, marginTop: '10px', marginLeft: '0px', marginRight: '5px'}} label={data.name} src="https://www.workload.co/wp-content/uploads/servicetitan.png" alt={data.name}>
          <AppsIcon style={ {width : 20,height:20 } }  />
    </Avatar> */}

                        </Paper>
                    </Grid>
                    <Grid item xs={breakpoint !== 'large' ? 12 : 4}>
                        <Paper onClick={() => handleTriggerClick('schedule')} className={classes.paper}>
                            <Avatar style={{ width: 30, height: 30, display: 'flex', float: 'left', marginTop: '2px', marginLeft: '0px', marginRight: '5px' }} src="https://cdn.workload.co/wp-content/uploads/2021/07/schedule.svg" >
                                <AppsIcon style={{ width: 20, height: 20 }} />
                            </Avatar>
                            <Typography style={{ fontSize: '13px', marginTop: '2px', fontWeight: 'bold', }} >Schedule</Typography>
                            <Typography style={{ fontSize: '11px', marginTop: '-1px', marginLeft: '35px' }} >Start your workflow on a custom timer</Typography>
                        </Paper>
                        <Paper style={{ marginRight: 4, marginLeft: 4 }} onClick={() => handleTriggerClick('webhook')} className={classes.paper}>
                            <Avatar style={{ width: 30, height: 30, display: 'flex', float: 'left', marginTop: '2px', marginLeft: '0px', marginRight: '5px' }} src="https://cdn.workload.co/wp-content/uploads/2021/09/webhook-1.png" >
                                <AppsIcon style={{ width: 20, height: 20 }} />
                            </Avatar>
                            <Typography style={{ fontSize: '13px', marginTop: '2px', fontWeight: 'bold',  }} >Webhook</Typography>
                            <Typography style={{ fontSize: '11px',  marginTop: '-1px', marginLeft: '35px' }} >Trigger workflow when another app sends a webhook</Typography>
                        </Paper>
                        <Paper style={{ marginRight: 4, marginLeft: 4 }} onClick={() => handleTriggerClick('workload-forms')} className={classes.paper}>
                            <Avatar style={{ width: 30, height: 30, display: 'flex', float: 'left', marginTop: '2px', marginLeft: '0px', marginRight: '5px' }} src="https://cdn.workload.co/wp-content/uploads/workload-forms.png" >
                                <AppsIcon style={{ width: 20, height: 20 }} />
                            </Avatar>
                            <Typography style={{ fontSize: '13px', marginTop: '2px', fontWeight: 'bold',}} >Forms by Workload</Typography>
                            <Typography style={{ fontSize: '11px', marginTop: '-1px', marginLeft: '35px' }} >Trigger workflow when a form is submitted</Typography>
                        </Paper>
                    </Grid>
                </Grid>
                
                {/* Recent Apps */}
                {recentApps.length > 0 && (
                    <div style={{ marginTop: '24px', marginBottom: '16px', paddingLeft: '8px', paddingRight: '8px' }}>
                        <Typography variant="body2" style={{ fontWeight: 600, marginBottom: '8px', fontSize: '12px', color: '#666', textTransform: 'none', letterSpacing: '0.5px' }}>
                            Recent Apps
                        </Typography>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                            {recentApps.map((appObj, index) => (
                                <Chip
                                    size="small"
                                    variant="outlined"
                                    key={`${appObj.name}-${index}`}
                                    avatar={<Avatar src={appObj.icon} style={{ width: '20px', height: '20px' }} />}
                                    label={appObj.name}
                                    onClick={() => handleChipClick(appObj)}
                                    style={{ 
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                        fontWeight: 500
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>                :
                <div className={mainPanelClassName} style={{ paddingTop: '75px', maxWidth: '100%', minWidth: 0, overflow: 'hidden', ...panelWrapStyle }}>
                    <div id="headerbox" className={classes.headerbox}>
                        <IconButton style={{ float: 'right', display: 'block', borderRadius: 50, marginRight: '5px' }} aria-label="close modal" onClick={() => { flushFormThenSave((latest) => { saveNode(null, latest); dispatch(saveWorkflow(1)); }); onPaneClick(); handleSaveClick(); }}>
                            <HighlightOffRoundedIcon  />
                        </IconButton>
                        {(icon || node?.data?.icon) && !iconErrorRef.current ? (
                            <img 
                                style={{ width: breakpoint !== 'large' ? '36px' : '48px', height: breakpoint !== 'large' ? '36px' : '48px', float: 'left', boxShadow: '-1px 2px 3px 2px silver', borderRadius: '50%', marginLeft: breakpoint !== 'large' ? '5px' : null }} 
                                src={icon || node?.data?.icon} 
                                alt={label}
                                onError={(e) => {
                                    iconErrorRef.current = true;
                                    // Force re-render by clearing icon
                                    setIcon('');
                                }}
                                onLoad={() => {
                                    // Reset error ref when image loads successfully
                                    iconErrorRef.current = false;
                                }}
                            />
                        ) : (
                            <Avatar style={{ marginRight: '10px', float: 'left' }}>
                                <AppsRoundedIcon />
                            </Avatar>
                        )}                        
                        <Input startAdornment={
                                <InputAdornment position="start">
                                    <CreateRoundedIcon style={{ color: 'silver', fontSize: breakpoint !== 'large' ? '14px' : null }} />
                                </InputAdornment>
                            } style={{ width: breakpoint === 'small' ? '175px' : null, marginTop: '5px', marginLeft: breakpoint !== 'large' ? '8px' : '16px', minWidth: breakpoint !== 'large' ? '50%' : '75%', fontSize: breakpoint !== 'large' ? '16px' : '24px', fontWeight: 'bold' }} id="name" onChange={e => { 
                                setName(e.target.value)
                            }} defaultValue={node.data.name} value={node.data.name === 'Add trigger' ? 'Name this Step' : name} placeholder="Name this step..." />
                    </div>
                    <div style={{ float: 'clear', marginBottom: '20px' }}></div>
                    <Divider />
                    <Stepper style={{ borderRadius: '0px 0px 8px 8px', padding: inlineLayout ? '24px 12px 8px 6px' : '24px 8px 8px 0px' }} activeStep={activeStep} orientation='vertical' connector={<div style={{height:'20px', borderBottom: '1px solid lightgray', marginBottom:'25px' }} />} >
                        <Step key="App Step" >
                            <StepButton onClick={(e) => { setStep(0) }}><div><Typography style={{ fontSize: '18px', display:'block', float: 'left' }}><strong>App</strong></Typography>{activeStep === 0 ? <Carat active={activeStep === 0 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /> : <Carat active={activeStep === 0 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} />}</div></StepButton>
                            <StepContent style={{ paddingLeft: '8px', marginLeft: '8px', borderLeft: 'none' }}>
                                <br />
                                <FormControl variant="outlined" style={{ width: '100%' }} >

                                    <Autocomplete
                                        autoComplete
                                        clearOnBlur
                                        key="app-selection"
                                        id="combo-box-demo"
                                        options={allApps}
                                        value={label}
                                        open={appopen}
                                        filterOptions={allAppsFilterOptions}
                                        onOpen={() => {
                                            setAppOpen(true);
                                        }}
                                        onClose={() => {
                                            setAppOpen(false);
                                        }}
                                        loading={apploading}
                                        getOptionLabel={(option) => option.name ?? label ?? ""}
                                        style={{ width: breakpoint !== 'large' ? '100%' : '100%', height: '60px' }}
                                        onChange={(e, v) => { 
                                            if (v === null) {
                                                // Clear app - reset all node data and show empty trigger modal
                                                // Set flag to prevent sync useEffect from interfering
                                                isManualSaveRef.current = true;
                                                
                                                // Clear all state
                                                setApp('');
                                                setLabel('');
                                                setIcon('');
                                                setCustomButton('');
                                                setURL('');
                                                setHasAuth(false);
                                                setTrigger({ key: '', label: '' });
                                                setTriggerLabel('');
                                                setCredentialId(null);
                                                setAuthname(null);
                                                setTriggerMessage('');
                                                setTriggerChoices('');
                                                setChoice('');
                                                setTestData('');
                                                setPollingParams('');
                                                setPerformList('');
                                                setWebhookKey('');
                                                setUnsubscribe('');
                                                setType('');
                                                setName('Add trigger');
                                                setFields([]);
                                                
                                                // Save the cleared node data
                                                setTimeout(() => {
                                                    saveNode('cleared app');
                                                    setStep(0); // Go back to empty trigger modal
                                                    // Clear flag after save completes
                                                    setTimeout(() => {
                                                        isManualSaveRef.current = false;
                                                    }, 100);
                                                }, 0);
                                            } else {
                                                // App selected - use existing logic
                                                setNodeNameAuto(v.name, undefined); 
                                                setApp(v.app); 
                                                sendTriggerData(v.app); 
                                                setTrigger(''); 
                                                setTriggerMessage(''); 
                                                setTriggerChoices(''); 
                                                setChoice(''); 
                                                setTestData('');
                                                saveNode('changed app'); 
                                                setIcon(v.icon); 
                                                setHasAuth(v.auth); 
                                                setLabel(v.name);
                                                setCustomButton(v.custombutton); 
                                                setURL(v.formDataEndpoint); 
                                                saveNode('changed app'); 
                                                setStep(activeStep + 1);
                                            }
                                        }}
                                        renderOption={(option) => (
                                            <MenuItem style={{ width: '100%' }}>
                                                <span>
                                                    <Avatar style={{ padding: '4px', width: '32px', height: '32px', marginRight: '10px' }} src={option.icon} />
                                                </span>
                                                {option.name}
                                            </MenuItem>
                                        )}
                                        renderInput={(params) => (
                                            <div style={{ position: "relative" }}>
                                                {params.inputProps.value && (

                                                    <span>
                                                        {/* Write logic to have Icon from params.inputProps.value */}
                                                        {<Avatar style={{
                                                            position: "absolute",
                                                            transform: "translateY(40%)",
                                                            marginLeft: "10px",
                                                            width: '32px', height: '32px', marginRight: '30px'
                                                        }} src={icon} />}
                                                    </span>
                                                )}
                                                <TextField
                                                    {...params}
                                                    label="Type to search for an App"
                                                    variant="outlined"
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        autoComplete: "off",
                                                        style: { paddingLeft: "45px" } // disable autocomplete and autofill
                                                    }}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {allApps.length === 0 ? <CircularProgress style={{ marginRight: 20 }} color={colors[color]} size={30} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        )

                                                    }}
                                                />
                                            </div>
                                        )}
                                    />
                                </FormControl>
                                <br /><br />
                                <div className={classes.triggersContainer}>
                                    <div>
                                    </div>
                                </div>

                            </StepContent>
                        </Step>
                        <Step key='Trigger Step' disabled={app ? 0 : 1}>
                            { !node.data.action ? <StepButton onClick={(e) => { setStep(1) }} icon={<WarningRounded style={{color: 'orange'}}/>} ><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Event</strong></Typography><Carat active={activeStep === 1 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> : <StepButton onClick={(e) => { setStep(1) }}  ><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Event</strong></Typography><Carat active={activeStep === 1 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> }
                            <StepContent style={{ paddingLeft: '8px', marginLeft: '8px', borderLeft: 'none' }}>
                                {
                                    triggers ?
                                        <Autocomplete
                                            autoComplete
                                            //clearOnBlur
                                            freeSolo={true}
                                            id="choose-event-trigger"
                                            open={triggersopen}
                                            value={trigger ?? ''}
                                            onOpen={() => {
                                                setTriggersOpen(true);
                                            }}
                                            onClose={() => {
                                                setTriggersOpen(false);
                                            }}
                                            loading={!loadedTriggers}
                                            loadingText="Loading Triggers..."
                                            noOptionsText={<div><Typography color="default">Looks like no one has created a trigger for {label} yet...</Typography>
                                                <Divider /><br />
                                                <Button variant='contained'
                                                    style={{ textTransform: 'none', backgroundColor: 'black', color: 'white', fontWeight: 600 }}
                                                    onMouseDown={() => {
                                                        handleModalOpen();
                                                    }}>
                                                    + Create a new trigger
                                                </Button></div>}
                                            options={triggeroptions.sort((a,b) => a.key.localeCompare(b.key))}
                                            //groupBy={(option) => option.key}
                                            getOptionSelected={(opt, val) => opt.label == val.label}
                                            getOptionLabel={(option) => eventLabel || (option.label ?? option.key ?? "")}
                                            onChange={(e, v) => { 
                                                if (v === null) {
                                                    v = "";
                                                } else if (v === trigger) {
                                                    setStep(activeStep + 1);
                                                } else {
                                                    // Set flag to prevent sync useEffect from interfering
                                                    isManualSaveRef.current = true;
                                                    
                                                    // Clear related state
                                                    setTriggerMessage('');
                                                    setTimeLeft(61);
                                                    setTestData('');
                                                    
                                                    // Update event-related state
                                                    setNodeNameAuto(label, v.label || eventLabel);
                                                    setTrigger({ ...v });
                                                    setTriggerLabel(v.label || eventLabel);
                                                    // Built-in apps (schedule, webhook, workload-forms) must NOT have performList/triggerResource
                                                    // or the backend will try getDD (polling-style) and return 500
                                                    const isBuiltIn = app === BUILT_IN_TRIGGER_APPS.SCHEDULE || app === BUILT_IN_TRIGGER_APPS.WEBHOOK || app === BUILT_IN_TRIGGER_APPS.WORKLOAD_FORMS;
                                                    if (isBuiltIn) {
                                                        setPerformList('');
                                                        setPollingParams({});
                                                    } else {
                                                        setPollingParams(v.pollingParams);
                                                        setPerformList(v.performList);
                                                    }
                                                    setUnsubscribe(v.unsubscribe);
                                                    setWebhookKey(v.webhookKey);
                                                    sendTriggerEventData(app, v.label);
                                                    setTriggerChoiceTime(Date.now());
                                                    
                                                    // Track event selected
                                                    trackEventSelected(label, v.label, 'trigger');
                                                    
                                                    // Save the changes with description after state updates
                                                    setTimeout(() => {
                                                        saveNode('changed event');
                                                        
                                                        // For webhook and workload-forms triggers, create the trigger to get the URL
                                                        if ((app === 'webhook' && type === 'webhook') || app === 'workload-forms') {
                                                            // Set loading state
                                                            setCreatingWebhookTrigger(true);
                                                            
                                                            // Save workflow first to ensure backend has latest data
                                                            dispatch(saveWorkflow(1)).then(() => {
                                                                // Then create the trigger to get webhook/form URL
                                                                dispatch(createTrigger(workflowID)).then((response) => {
                                                                    if (response.payload && response.payload.triggerMessage) {
                                                                        // Set the triggerMessage which contains the webhook/form URL
                                                                        const message = response.payload.triggerMessage;
                                                                        setTriggerMessage(message);
                                                                        // Also update Redux node to persist the triggerMessage
                                                                        dispatch(elementUpdated(selectedNode.id, {
                                                                            ...node.data,
                                                                            triggerMessage: message
                                                                        }, null, null));
                                                                        // Update refs to prevent sync useEffect from overwriting
                                                                        prevFieldsRef.current = fields;
                                                                        prevNodeStateRef.current = { name, app, label, icon, hasauth, trigger: v, credentialId, authname };
                                                                        // Save the updated node with triggerMessage
                                                                        saveNode('changed event');
                                                                    }
                                                                    // Clear loading state
                                                                    setCreatingWebhookTrigger(false);
                                                                    // Clear flag after trigger creation completes
                                                                    setTimeout(() => {
                                                                        isManualSaveRef.current = false;
                                                                    }, 100);
                                                                }).catch((error) => {
                                                                    console.error('Error creating trigger:', error);
                                                                    setCreatingWebhookTrigger(false);
                                                                    isManualSaveRef.current = false;
                                                                });
                                                            }).catch((error) => {
                                                                console.error('Error saving workflow:', error);
                                                                setCreatingWebhookTrigger(false);
                                                                isManualSaveRef.current = false;
                                                            });
                                                        } else {
                                                            // Clear flag after save completes for other triggers
                                                            setTimeout(() => {
                                                                isManualSaveRef.current = false;
                                                            }, 100);
                                                        }
                                                    }, 0);
                                                }
                                            }}
                                            style={{ width: '100%' }}
                                            PaperComponent={PaperComponentCustom}
                                            renderOption={(option) => (
                                                <li style={{ listStyleType: 'none', padding: 4 }} id={option.label} key={option.key}>
                                                   <Typography style={{fontWeight: 'bold', fontSize: '20px'}}>{option.label ?? option.key}</Typography>
                                                   <Typography style={{fontWeight: 300, fontSize: '16px'}}>{option.description}</Typography>
                                                </li>

                                            )}
                                            renderInput={(params) => <TextField {...params} label='Type to search for a Trigger' variant="outlined" helperText="This is what starts an automated workflow."
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <React.Fragment>
                                                            {!loadedTriggers ? <CircularProgress color={colors[color]} size={20} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </React.Fragment>
                                                    ),
                                                }} />}

                                        />
                                        :
                                        null
                                }

                                <div className={classes.triggersContainer}>
                                    {/* Show webhook URL in Event step for webhook triggers */}
                                    {app === 'webhook' && type === 'webhook' && (
                                        <div style={{ width: '100%', maxWidth: '100%', overflowX: 'hidden', marginBottom: '20px', minWidth: 0 }}>
                                            {creatingWebhookTrigger ? (
                                                <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                                                    <CircularProgress style={{ margin: '20px auto', display: 'block' }} size={50} />
                                                    <Typography variant="body2" style={{ marginTop: '20px', color: '#666' }}>
                                                        Creating webhook trigger...
                                                    </Typography>
                                                </div>
                                            ) : triggerMessage ? (
                                    <div>
                                                    <InputLabel htmlFor="outlined-adornment-password"><Typography variant="h6" style={{ color: 'black' }}><strong>Copy Webhook</strong></Typography></InputLabel>
                                                    <FormHelperText id={"descriptionntext"}><Typography variant="body2">Copy this webhook URL and paste into the application you are trying to send events from.</Typography> </FormHelperText>
                                                    <br />
                                                    <OutlinedInput
                                                        disabled
                                                        style={{ width: '100%' }}
                                                        id={'webhook-copy-event'}
                                                        key={'webhook-copy-event'}
                                                        label={'Webhook URL'}
                                                        defaultValue={triggerMessage['Webhook URL']}
                                                        helperText={'Copy this URL to paste into other software tools.'}
                                                        variant="outlined"
                                                        endAdornment={
                                                            <InputAdornment position="end" className={classes.icon}>
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={() => {
                                                                        const webhookUrl = triggerMessage['Webhook URL'];
                                                                        if (webhookUrl) {
                                                                            navigator.clipboard.writeText(webhookUrl).then(() => {
                                                                                dispatch(notification({ "status": "info", "message": "Copied to clipboard" }))
                                                                            }).catch((err) => {
                                                                                console.error('Failed to copy to clipboard:', err);
                                                                                dispatch(notification({ "status": "error", "message": "Failed to copy to clipboard" }))
                                                                            });
                                                                        }
                                                                    }}
                                                                    edge="end"
                                                                >
                                                                    <Divider orientation="vertical" flexItem style={{ marginRight: '8px' }} />
                                                                    <FileCopyOutlinedIcon />
                                                                </IconButton>
                                                                <Typography style={{ marginTop: '40px', marginLeft: '-25px' }} variant="caption" display="block" gutterBottom>
                                                                    copy
                                                                </Typography>
                                                            </InputAdornment>
                                                        }
                                                        labelWidth={70}
                                                    />
                                                </div>
                                            ) : null}
                                        </div>
                                    )}
                                    {/* Show form URL in Event step for workload-forms triggers */}
                                    {app === 'workload-forms' && (
                                        <div style={{ width: '100%', maxWidth: '100%', overflowX: 'hidden', marginBottom: '20px', minWidth: 0 }}>
                                            {creatingWebhookTrigger ? (
                                                <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                                                    <CircularProgress style={{ margin: '20px auto', display: 'block' }} size={50} />
                                                    <Typography variant="body2" style={{ marginTop: '20px', color: '#666' }}>
                                                        Creating form trigger...
                                                    </Typography>
                                                </div>
                                            ) : triggerMessage ? (
                                    <div>
                                                    <InputLabel htmlFor="outlined-adornment-password"><Typography variant="h6" style={{ color: 'black' }}><strong>Copy Form URL</strong></Typography></InputLabel>
                                                    <FormHelperText id={"descriptionntext"}><Typography variant="body2">Copy this Form URL and paste into a browser to view and use.</Typography> </FormHelperText>
                                                    <br />
                                                    <OutlinedInput
                                                        disabled
                                                        style={{ width: '100%' }}
                                                        id={'form-copy-event'}
                                                        key={'form-copy-event'}
                                                        label={'Form URL'}
                                                        defaultValue={'https://editor.workload.co/form/'+work_id}
                                                        helperText={'Copy this URL to paste into a browser window to view and submit form entries.'}
                                                        variant="outlined"
                                                        endAdornment={
                                                            <InputAdornment position="end" className={classes.icon}>
                                                                <IconButton
                                                                    aria-label="copy form url"
                                                                    onClick={() => {
                                                                        navigator.clipboard.writeText('https://editor.workload.co/form/'+work_id).then(() => {
                                                                            dispatch(notification({ "status": "info", "message": "Copied to clipboard" }))
                                                                        }).catch((err) => {
                                                                            console.error('Failed to copy to clipboard:', err);
                                                                            dispatch(notification({ "status": "error", "message": "Failed to copy to clipboard" }))
                                                                        });
                                                                    }}
                                                                    edge="end"
                                                                >
                                                                    <Divider orientation="vertical" flexItem style={{ marginRight: '8px' }} />
                                                                    <FileCopyOutlinedIcon />
                                                                </IconButton>
                                                                <Typography style={{ marginTop: '40px', marginLeft: '-25px' }} variant="caption" display="block" gutterBottom>
                                                                    copy
                                                                </Typography>
                                                            </InputAdornment>
                                                        }
                                                        labelWidth={70}
                                                    />
                                                </div>
                                            ) : null}
                                        </div>
                                    )}
                                    
                                    <div>
                                        <Button id='continue-button' style={{ width: breakpoint !== 'large' ? '100%' : '100%', textTransform: 'none', fontWeight: '600', fontSize: breakpoint !== 'large' ? '14px' : '18px' }} disabled={trigger.key ? 0 : 1} variant="contained" color="primary" onClick={e => {
                                            if (hasauth === false) {
                                                // For webhook and workload-forms triggers, wait for triggerMessage before advancing
                                                if ((app === 'webhook' && type === 'webhook' && !triggerMessage) || (app === 'workload-forms' && !triggerMessage)) {
                                                    // Don't advance yet - trigger creation is in progress
                                                    // The trigger creation happens in the onChange handler above
                                                    return;
                                                }

                                                if (triggerMessage) {
                                                    dispatch(saveWorkflow(1))
                                                    setStep(activeStep + 1)
                                                    saveNode()
                                                } else {
                                                    // Trigger creation removed - proceed to next step
                                                        setStep(activeStep + 1);
                                                        saveNode()
                                                }
                                            } else {
                                                setStep(activeStep + 1)
                                            }
                                        }}>{hasauth === true ? 'Continue' : 'Continue'}</Button>
                                    </div>
                                </div>
                            </StepContent>
                        </Step>
                        
                        {trigger.key ? hasauth ?
                            <Step key='Auth Step' disabled={trigger ? 0 : 1} >
                               
                              { !credentialId ?? credentialId === '' ? <StepButton onClick={(e) => { setStep(2) }} icon={<WarningRounded style={{color: 'orange'}} />}><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Account</strong></Typography><Carat active={activeStep === 2 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> : <StepButton onClick={(e) => { setStep(2) }}><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Account</strong></Typography><Carat active={activeStep === 2 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> }
                              
                                <StepContent style={{ paddingLeft: '8px', marginLeft: '8px', borderLeft: 'none' }}>
                                    <Authorizer
                                        breakpoint={breakpoint}
                                        user={user}
                                        sendLoggedOutToAuthorizer={sendLoggedOutToAuthorizer}
                                        tenant={tenant}
                                        node={node}
                                        app={app}
                                        applabel={label}
                                        icon={icon}
                                        sendData={setCredentialId}
                                        sendAuth={setAuthname}
                                        saveNode={saveNode}
                                        value={authname}
                                    />
                                    <div className={classes.triggersContainer}>
                                        <div>
                                            
                                            <Button id='trigger-next' style={{ width: breakpoint !== 'large' ? '100%' : '100%', textTransform: 'none', fontWeight: '600', fontSize: breakpoint !== 'large' ? '14px' : '18px' }} disabled={credentialId ? 0 : 1} variant="contained" color="primary" onClick={fields && fields.find(item => item.hidden !== true) ? handleSetUpTrigger : handleSetUpTriggerTest} >{fields && fields.find(item => item.hidden !== true) ? 'Continue' : 'Continue' }</Button>
                                        </div>
                                    </div>
                                </StepContent>
                            </Step> :
                            null : null}
                            
                        {trigger.key ? fields ? fields.find(item => item.hidden !== true) ?
                            <Step key='Set up Trigger Step' disabled={trigger.key && (!hasauth || (hasauth && authname)) ? 0 : 1}>
                               { fields.some(e => e.value) === false ? <StepButton icon={<WarningRounded style={{color: 'orange'}} />} onClick={(e) => { app === 'schedule' ? setStep(2) : setStep(3) }}><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Trigger</strong></Typography><Carat active={activeStep === 3 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> : <StepButton onClick={(e) => {app === 'schedule' ? setStep(2) : setStep(3) }} ><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Trigger</strong></Typography><Carat active={activeStep === 3 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> } 
                                <StepContent style={{ paddingLeft: '8px', marginLeft: '8px', borderLeft: 'none' }}>
                                    <div id='trigger-setup' style={{ height: '1px' }}></div>
                                    {
                                        fields ?
                                            <FieldsRender fields={fields} setFields={setFieldsAndPersist} parentTree={parentTree} nodeID={node.id} />
                                            : null
                                    }

                                    <div className={classes.triggersContainer}>
                                        <div>
                                           
                                            <Button style={{ width: breakpoint !== 'large' ? '100%' : '100%', textTransform: 'none', fontWeight: '600', fontSize: breakpoint !== 'large' ? '14px' : '18px' }} disabled={trigger ? 0 : 1 || !areRequiredFieldsFilled()} variant="contained" color="primary" onClick={e => {
                                                flushFormThenSave((latest) => {
                                                  saveNode(null, latest);
                                                  performList ? handlePerformList() : handleSetUpTriggerTest();
                                                });
                                            }}>{'Continue'}</Button>
                                        </div>
                                    </div>
                                </StepContent>
                            </Step> : null : null : null}
                           
                        <Step key='Test Step' disabled={trigger && (!hasauth || (hasauth && authname)) ? 0 : 1}>

                           { !testData && !triggerMessage || !testData && !triggerChoices ? <StepButton disabled={trigger.key && (!hasauth || (hasauth && authname)) ? 0 : 1} onClick={async (e) => { 
                            // For webhook triggers, fetch recent payloads when Test step opens
                            if (app === 'webhook' && type === 'webhook') {
                                hasFetchedRecentPayloadsRef.current = false; // Reset to allow fresh fetch
                                await fetchRecentWebhookPayloads();
                            }
                            // For workload-forms triggers, fetch recent form submissions when Test step opens
                            if (app === 'workload-forms') {
                                hasFetchedFormSubmissionsRef.current = false; // Reset to allow fresh fetch
                                await fetchRecentFormSubmissions();
                            }
                            app === 'schedule' ? setStep(3) : hasauth ? setStep(testStep) : setStep(testStep);
                        }} icon={<WarningRounded style={{color: 'orange'}} />}><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Test</strong></Typography><Carat active={activeStep === 99 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> : <StepButton disabled={trigger.key && (!hasauth || (hasauth && authname)) ? 0 : 1} onClick={async (e) => {
                            // For webhook triggers, fetch recent payloads when Test step opens
                            if (app === 'webhook' && type === 'webhook') {
                                // Reset to allow fresh fetch
                                hasFetchedRecentPayloadsRef.current = false;
                                // Set loading state BEFORE changing step so spinner shows immediately
                                setLoadingRecentPayloads(true);
                                // Change step first so the loading UI is visible
                                app === 'schedule' ? setStep(3) : hasauth ? setStep(testStep) : setStep(testStep);
                                // Use setTimeout to ensure step change renders before fetching
                                setTimeout(async () => {
                                    // Fetch payloads (this will clear loading state when done)
                                    await fetchRecentWebhookPayloads(true); // forceRefresh = true to bypass duplicate check
                                }, 0);
                            } else if (app === 'workload-forms') {
                                // For workload-forms triggers, fetch recent form submissions when Test step opens
                                // Reset to allow fresh fetch
                                hasFetchedFormSubmissionsRef.current = false;
                                // Set loading state BEFORE changing step so spinner shows immediately
                                setLoadingFormSubmissions(true);
                                // Change step first so the loading UI is visible
                                app === 'schedule' ? setStep(3) : hasauth ? setStep(testStep) : setStep(testStep);
                                // Use setTimeout to ensure step change renders before fetching
                                setTimeout(async () => {
                                    // Fetch form submissions (this will clear loading state when done)
                                    await fetchRecentFormSubmissions(true); // forceRefresh = true to bypass duplicate check
                                }, 0);
                            } else {
                                app === 'schedule' ? setStep(3) : hasauth ? setStep(testStep) : setStep(testStep);
                            }
                        }} ><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Test</strong></Typography><Carat active={activeStep === 99 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> } 

                            {loadingchoices || loadingRecentPayloads || loadingFormSubmissions ? <CircularProgress style={{ marginLeft: '30%', marginTop: '20px' }} id='circularprogresscolor' color={colors[color]} size={50} /> : null}
                            {loadingchoices || loadingRecentPayloads || loadingFormSubmissions ? <Typography style={{ marginLeft: '30%', marginTop: '20px' }} id='circularprogresscolor' color={colors[color]} size={50}>Loading...</Typography> : null}
                            <StepContent style={{ paddingLeft: '8px', marginLeft: '8px', borderLeft: 'none' }}>
                                <div className={classes.triggersContainer}>
                                    {/* Show form URL for workload-forms triggers (similar to webhook URL) */}
                                    {triggerMessage && app === 'workload-forms' ? (
                                        <div style={{ width: '100%', maxWidth: '100%', overflowX: 'hidden', marginBottom: '20px', minWidth: 0 }}>
                                            <InputLabel htmlFor="outlined-adornment-password"><Typography variant="h6" style={{ color: 'black' }}><strong>Copy Form URL</strong></Typography></InputLabel>
                                            <FormHelperText id={"descriptionntext"}><Typography variant="body2">Copy this Form URL and paste into a browser to view and use.</Typography> </FormHelperText>
                                            <br />
                                            <OutlinedInput
                                                disabled
                                                style={{ width: '100%' }}
                                                id={'form-copy'}
                                                key={'form-copy'}
                                                label={'Form URL'}
                                                defaultValue={'https://editor.workload.co/form/'+work_id}
                                                helperText={'Copy this URL to paste into a browser window to view and submit form entries.'}
                                                variant="outlined"
                                                endAdornment={
                                                    <InputAdornment position="end" className={classes.icon}>
                                                        <IconButton
                                                            aria-label="copy form url"
                                                            onClick={() => {
                                                                navigator.clipboard.writeText('https://editor.workload.co/form/'+work_id).then(() => {
                                                                    dispatch(notification({ "status": "info", "message": "Copied to clipboard" }))
                                                                }).catch((err) => {
                                                                    console.error('Failed to copy to clipboard:', err);
                                                                    dispatch(notification({ "status": "error", "message": "Failed to copy to clipboard" }))
                                                                });
                                                            }}
                                                            edge="end"
                                                        >
                                                            <Divider orientation="vertical" flexItem style={{ marginRight: '8px' }} />
                                                            <FileCopyOutlinedIcon />
                                                        </IconButton>
                                                        <Typography style={{ marginTop: '40px', marginLeft: '-25px' }} variant="caption" display="block" gutterBottom>
                                                            copy
                                                        </Typography>
                                                    </InputAdornment>
                                                }
                                                labelWidth={70}
                                            />
                                        </div>
                                    ) : null}
                                    
                                    {triggerMessage || triggerChoices || loadingchoices || (app === 'webhook' && type === 'webhook' && (recentWebhookPayloads.length > 0 || loadingRecentPayloads)) || (app === 'workload-forms' && (recentFormSubmissions.length > 0 || loadingFormSubmissions)) ? (
                                        <div>
                                            <div><br /> <br />
                                                {/* Show loading state while fetching trigger choices for polling triggers */}
                                                {type === 'polling' && loadingchoices && !triggerChoices ? (
                                                    <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                                                        <CircularProgress style={{ margin: '20px auto', display: 'block' }} size={50} />
                                                        <Typography variant="body2" style={{ marginTop: '20px', color: '#666' }}>
                                                            Fetching trigger choices...
                                                        </Typography>
                                                    </div>
                                                ) : null}
                                                
                                                {/* Show loading state while fetching recent webhook payloads */}
                                                {app === 'webhook' && type === 'webhook' && loadingRecentPayloads && recentWebhookPayloads.length === 0 ? (
                                                    <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                                                        <CircularProgress style={{ margin: '20px auto', display: 'block' }} size={50} />
                                                        <Typography variant="body2" style={{ marginTop: '20px', color: '#666' }}>
                                                            Fetching recent webhook payloads...
                                                        </Typography>
                                                    </div>
                                                ) : null}
                                                
                                                {/* For webhook triggers, show recent payloads dropdown matching polling triggerChoices style */}
                                                {app === 'webhook' && type === 'webhook' && recentWebhookPayloads.length > 0 && !awaitingTrigger && !loadingRecentPayloads ? (
                                                    <Fragment>
                                                        <Alert severity="success" variant="outlined" style={{borderWidth: '0px 0px 0px 6px', borderStyle: 'none none none solid'}}>
                                                            <AlertTitle>{eventLabel} found!</AlertTitle>
                                                            {eventLabel} was found in your {label} account...
                                                        </Alert>
                                                        <Select
                                                            MenuProps={{
                                                                anchorOrigin: {
                                                                    vertical: "bottom",
                                                                    horizontal: "left"
                                                                },
                                                                transformOrigin: {
                                                                    vertical: "top",
                                                                    horizontal: "left"
                                                                },
                                                                getContentAnchorEl: null
                                                            }}
                                                            id='webhook-payload-select'
                                                            style={{ width: '100%', padding: 0, marginTop: '12px', marginBottom: '12px' }}
                                                            labelId="webhook-payload-select-label"
                                                            value={(triggerchoice === 'Trigger 1' && (app === 'webhook' || app === 'workload-forms') ? eventLabel + ' 1' : triggerchoice) ?? eventLabel + " 1"}
                                                            onChange={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                const selectedValue = e.target.value;
                                                                
                                                                // Extract index from value (e.g., "Webhook Received 2" -> index 1)
                                                                const match = selectedValue.match(/\d+$/);
                                                                if (match) {
                                                                    const selectedIdx = parseInt(match[0]) - 1; // Convert to 0-based index
                                                                    if (selectedIdx >= 0 && selectedIdx < recentWebhookPayloads.length) {
                                                                        const selectedPayload = recentWebhookPayloads[selectedIdx];
                                                                        if (selectedPayload) {
                                                                            // Set flag to prevent sync useEffect from interfering
                                                                            isManualSaveRef.current = true;
                                                                            
                                                                            // Update state immediately
                                                                            setTestData(selectedPayload.payload);
                                                                            setChoice(selectedValue);
                                                                            setTriggerChoiceTime(selectedPayload.timestamp || Date.now());
                                                                            
                                                                            // Force re-render by updating refs
                                                                            prevFieldsRef.current = fields;
                                                                            prevNodeStateRef.current = { name, app, label, icon, hasauth, trigger, credentialId, authname };
                                                                            
                                                                            // Save after state updates complete - ensure testData is saved to node.data for use in picker
                                                                            setTimeout(() => {
                                                                                saveNode();
                                                                                // Also explicitly update Redux node data to ensure testData is saved
                                                                                dispatch(elementUpdated(selectedNode.id, {
                                                                                    ...node.data,
                                                                                    testData: selectedPayload.payload,
                                                                                    triggerchoice: selectedValue,
                                                                                    triggerChoiceTime: selectedPayload.timestamp || Date.now()
                                                                                }, null, null));
                                                                                // Clear flag after save completes
                                                                                setTimeout(() => {
                                                                                    isManualSaveRef.current = false;
                                                                                }, 100);
                                                                            }, 0);
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            renderValue={(value) => (<div><ListItemIcon style={{ float: 'left', display: 'block'}}>
                                                                <Avatar style={{width: breakpoint === 'small' ? '18px' : '26px', height: breakpoint === 'small' ? '18px' : '26px' }} src={icon} />
                                                            </ListItemIcon><Typography style={{ fontWeight: 'bold', fontSize: '20px',marginLeft: '8px', float:'left', display: 'block'}} >{value}</Typography></div>)}
                                                            variant="outlined"
                                                            placeholder={"Choose another trigger"}
                                                        >
                                                            <Typography style={{padding: '10px', fontWeight: 700}} variant="h6" >Choose another...</Typography>
                                                            <Divider style={{marginBottom: '6px'}} />
                                                            {recentWebhookPayloads.map((payload, idx) => (
                                                                <MenuItem id={idx} key={payload.id || idx} value={eventLabel + " " + (idx + 1)}>
                                                                    <ListItemIcon style={{ float: 'left', display: 'block'}}>
                                                                        <Avatar style={{width: breakpoint === 'small' ? '18px' : '26px', height: breakpoint === 'small' ? '18px' : '26px' }} src={icon} />
                                                                    </ListItemIcon>
                                                                    <Typography style={{ fontWeight: 'bold', fontSize: '20px',marginLeft: '8px', float:'left', display: 'block'}} >
                                                                        {eventLabel} {idx + 1}<br/>
                                                                        <div style={{fontSize: '12px', fontWeight: 300}}>{"Fetched "+timeSince(payload.timestamp || Date.now())+" ago"}</div>
                                                                    </Typography>
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        
                                                        {testData && testData !== "" ? (
                                                            <div id='inspector-json' style={{ maxHeight: '350px', overflowX: 'hidden', overflowY: 'scroll' }}>
                                                                <DataInspector data={testData} testData={testData} />
                                                            </div>
                                                        ) : null}
                                                        
                                                        <br /><br />
                                                        
                                                        <div id='trigger-save' style={{ width: '90%', height: '1px' }}></div>
                                                        
                                                        <Button style={{width: '100%', textTransform: 'none', marginBottom: '20px'}} disabled={nosave} variant='contained' color='primary' onClick={() => { flushFormThenSave((latest) => { saveNode(null, latest); dispatch(saveWorkflow(1)); sendAlert(); handleNextNodeOpen(); }); }}>
                                                            <Typography style={{fontSize: '20px'}}>Continue</Typography>
                                                        </Button>
                                                        <Button style={{width: '100%', textTransform: 'none'}} variant='text' onClick={() => { flushFormThenSave((latest) => { saveNode(null, latest); dispatch(saveWorkflow(1)); onPaneClick(); sendAlert(); }); }} >
                                                            Close
                                                        </Button>
                                                    </Fragment>
                                                ) : null}
                                                
                                                {/* Show loading state while fetching recent form submissions */}
                                                {app === 'workload-forms' && loadingFormSubmissions && recentFormSubmissions.length === 0 ? (
                                                    <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                                                        <CircularProgress style={{ margin: '20px auto', display: 'block' }} size={50} />
                                                        <Typography variant="body2" style={{ marginTop: '20px', color: '#666' }}>
                                                            Fetching recent form submissions...
                                                        </Typography>
                                                    </div>
                                                ) : null}
                                                
                                                {/* For workload-forms triggers, show recent form submissions dropdown matching webhook payloads style */}
                                                {app === 'workload-forms' && recentFormSubmissions.length > 0 && !awaitingTrigger && !loadingFormSubmissions && testData ? (
                                                    <Fragment>
                                                        <Alert severity="success" variant="outlined" style={{borderWidth: '0px 0px 0px 6px', borderStyle: 'none none none solid'}}>
                                                            <AlertTitle>{eventLabel} found!</AlertTitle>
                                                            {eventLabel} was found in your {label} account...
                                                        </Alert>
                                                        <Select
                                                            MenuProps={{
                                                                anchorOrigin: {
                                                                    vertical: "bottom",
                                                                    horizontal: "left"
                                                                },
                                                                transformOrigin: {
                                                                    vertical: "top",
                                                                    horizontal: "left"
                                                                },
                                                                getContentAnchorEl: null
                                                            }}
                                                            id='form-submission-select'
                                                            style={{ width: '100%', padding: 0, marginTop: '12px', marginBottom: '12px' }}
                                                            labelId="form-submission-select-label"
                                                            value={(triggerchoice === 'Trigger 1' && app === 'workload-forms' ? eventLabel + ' 1' : triggerchoice) ?? eventLabel + " 1"}
                                                            onChange={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                const selectedValue = e.target.value;
                                                                
                                                                // Extract index from value (e.g., "Form Submitted 2" -> index 1)
                                                                const match = selectedValue.match(/\d+$/);
                                                                if (match) {
                                                                    const selectedIdx = parseInt(match[0]) - 1; // Convert to 0-based index
                                                                    if (selectedIdx >= 0 && selectedIdx < recentFormSubmissions.length) {
                                                                        const selectedSubmission = recentFormSubmissions[selectedIdx];
                                                                        if (selectedSubmission) {
                                                                            // Set flag to prevent sync useEffect from interfering
                                                                            isManualSaveRef.current = true;
                                                                            
                                                                            // Update state immediately
                                                                            setTestData(selectedSubmission.payload);
                                                                            setChoice(selectedValue);
                                                                            setTriggerChoiceTime(selectedSubmission.timestamp || Date.now());
                                                                            
                                                                            // Force re-render by updating refs
                                                                            prevFieldsRef.current = fields;
                                                                            prevNodeStateRef.current = { name, app, label, icon, hasauth, trigger, credentialId, authname };
                                                                            
                                                                            // Save after state updates complete - ensure testData is saved to node.data for use in picker
                                                                            setTimeout(() => {
                                                                                saveNode();
                                                                                // Also explicitly update Redux node data to ensure testData is saved
                                                                                dispatch(elementUpdated(selectedNode.id, {
                                                                                    ...node.data,
                                                                                    testData: selectedSubmission.payload,
                                                                                    triggerchoice: selectedValue,
                                                                                    triggerChoiceTime: selectedSubmission.timestamp || Date.now()
                                                                                }, null, null));
                                                                                // Clear flag after save completes
                                                                                setTimeout(() => {
                                                                                    isManualSaveRef.current = false;
                                                                                }, 100);
                                                                            }, 0);
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            renderValue={(value) => (<div><ListItemIcon style={{ float: 'left', display: 'block'}}>
                                                                <Avatar style={{width: breakpoint === 'small' ? '18px' : '26px', height: breakpoint === 'small' ? '18px' : '26px' }} src={icon} />
                                                            </ListItemIcon><Typography style={{ fontWeight: 'bold', fontSize: '20px',marginLeft: '8px', float:'left', display: 'block'}} >{value}</Typography></div>)}
                                                            variant="outlined"
                                                            placeholder={"Choose another trigger"}
                                                        >
                                                            <Typography style={{padding: '10px', fontWeight: 700}} variant="h6" >Choose another...</Typography>
                                                            <Divider style={{marginBottom: '6px'}} />
                                                            {recentFormSubmissions.map((submission, idx) => (
                                                                <MenuItem id={idx} key={submission.id || idx} value={eventLabel + " " + (idx + 1)}>
                                                                    <ListItemIcon style={{ float: 'left', display: 'block'}}>
                                                                        <Avatar style={{width: breakpoint === 'small' ? '18px' : '26px', height: breakpoint === 'small' ? '18px' : '26px' }} src={icon} />
                                                                    </ListItemIcon>
                                                                    <Typography style={{ fontWeight: 'bold', fontSize: '20px',marginLeft: '8px', float:'left', display: 'block'}} >
                                                                        {eventLabel} {idx + 1}<br/>
                                                                        <div style={{fontSize: '12px', fontWeight: 300}}>{"Fetched "+timeSince(submission.timestamp || Date.now())+" ago"}</div>
                                                                    </Typography>
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        
                                                        {testData && testData !== "" ? (
                                                            <div id='inspector-json' style={{ maxHeight: '350px', overflowX: 'hidden', overflowY: 'scroll' }}>
                                                                <DataInspector data={testData} testData={testData} />
                                                            </div>
                                                        ) : null}
                                                        
                                                        <br /><br />
                                                        
                                                        <div id='trigger-save' style={{ width: '90%', height: '1px' }}></div>
                                                        
                                                        <Button style={{width: '100%', textTransform: 'none', marginBottom: '20px'}} disabled={nosave} variant='contained' color='primary' onClick={() => { flushFormThenSave((latest) => { saveNode(null, latest); dispatch(saveWorkflow(1)); sendAlert(); handleNextNodeOpen(); }); }}>
                                                            <Typography style={{fontSize: '20px'}}>Continue</Typography>
                                                        </Button>
                                                        <Button style={{width: '100%', textTransform: 'none'}} variant='text' onClick={() => { flushFormThenSave((latest) => { saveNode(null, latest); dispatch(saveWorkflow(1)); onPaneClick(); sendAlert(); }); }} >
                                                            Close
                                                        </Button>
                                                    </Fragment>
                                                ) : null}
                                                
                                                {/* For webhook triggers, only show Test Trigger button if no recent payloads available */}
                                                {app === 'webhook' && type === 'webhook' && recentWebhookPayloads.length === 0 && !loadingRecentPayloads ? (
                                                    <Button id='webhook-button' style={{ width: '100%', textTransform: 'none', fontSize: '18px' }} variant="contained" color="primary" onClick={async () => {
                                                        // Use same activation path as AppBar toggle (updateScaffold + activeUpdated + save) so webhook endpoint sees workflow as active
                                                        setTestData(triggerChoices ? triggerChoices[0] : null)
                                                        setChoice(triggerlabel +" "+1)
                                                        saveNode()
                                                        setAwaitingTrigger(performList ? false : true)
                                                        setTimeLeft(performList ? 61 : timeLeft - 1)
                                                        onActivateForListening?.()
                                                        await dispatch(saveWorkflow(1)) // Wait for save so backend has workflow ON before user sends webhook
                                                        setStep(99);
                                                    }}>
                                                        Test Trigger
                                                    </Button>
                                                ) : app === 'workload-forms' && triggerMessage && recentFormSubmissions.length === 0 && !loadingFormSubmissions ? (
                                                    <Button id='workload-forms-button' style={{ width: '100%', textTransform: 'none', fontSize: '18px' }} variant="contained" color="primary" onClick={async () => {
                                                        setTestData(triggerChoices ? triggerChoices[0] : null)
                                                        setChoice(triggerlabel +" "+1)
                                                        saveNode()
                                                        setAwaitingTrigger(performList ? false : true)
                                                        setTimeLeft(performList ? 61 : timeLeft - 1)
                                                        onActivateForListening?.()
                                                        await dispatch(saveWorkflow(1))
                                                        setStep(99);
                                                    }}>
                                                        Test Trigger
                                                    </Button>
                                                ) : app !== 'webhook' && app !== 'workload-forms' || (app === 'webhook' && type !== 'webhook') ? (
                                                    <Button id='test-trigger-button' style={{ width: '100%', textTransform: 'none', fontSize: '18px' }} variant="contained" color="primary" onClick={() => {
                                                        // For polling triggers with performList, fetch trigger choices first
                                                        if (type === 'polling' && performList) {
                                                            handleSetUpTriggerTest();
                                                        } else {
                                                            // For non-polling triggers or if no performList, set testData directly
                                                            setTestData(triggerChoices ? triggerChoices[0] : null)
                                                            setChoice(triggerlabel +" "+1)
                                                            saveNode()
                                                            setAwaitingTrigger(performList ? false : true)
                                                        }
                                                    }}>
                                                        Test Trigger
                                                    </Button>
                                                ) : null}
                                                
                                                <Button id='custom-webhook-button' style={{ width: '100%', textTransform: 'none', fontSize: '16px', marginTop: '25px' }} color="default" onClick={(e) => {
                                                    handlePopClick(e);
                                                }}>
                                                    Customize Trigger Data
                                                </Button>
                                                <Popper placement="left" id={id} open={openpop} anchorEl={anchorElPop} style={{ zIndex: 99 }}>
                                                    <div className={classes.popper}>
                                                        <React.Fragment>
                                                            <Typography color="inherit"><h4>Inject Sample Data</h4></Typography>
                                                            <em>{"Add JSON Object to simulate a webhook payload."}</em> 
                                                            <br /><br />
                                                            <TextareaAutosize defaultValue={poptext} value={poptext} onChange={(e) => setPopText(e.target.value)} style={{ width: '350px', maxWidth: '350px', height: '200px', borderColor: 'lightgray', maxHeight: '250px', overflowY: 'scroll' }} aria-label="minimum height" minRows={40} placeholder='{"data":{&#10;"key1":"value1",&#10;"key2":"value2"&#10; }&#10;}' />
                                                            <br /><br />
                                                            <Button onClick={handlePopClose} style={{ marginRight: '5px' }}>Close</Button><Button onClick={() => { setTestData(JSON.parse(poptext)); handlePopClose(); setStep(99) }} variant="contained" color="primary">Submit</Button>
                                                        </React.Fragment>
                                                    </div>
                                                </Popper>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div><br /> <br />
                                                {
                                                    app === 'schedule' ? (
                                                        // For schedule triggers, show spinner while creating trigger, then auto-show testData
                                                        !triggerMessage && !testData ? (
                                                            <CircularProgress style={{ marginLeft: '30%', marginTop: '20px' }} id='circularprogresscolor' color={colors[color]} size={50} />
                                                        ) : null
                                                    ) : (type == 'polling') && (triggerMessage || triggerChoices) ? (
                                                        <Button id='test-trigger-button' style={{ width: '100%', textTransform: 'none', fontSize: '18px' }} variant="contained" color="primary" onClick={() => {
                                                            // For polling triggers, call handleSetUpTriggerTest which will fetch trigger choices
                                                            if (type === 'polling' && performList) {
                                                                handleSetUpTriggerTest();
                                                            } else {
                                                                // For other triggers or if no performList, set testData directly
                                                                setTestData(triggerChoices ? triggerChoices[0] : null)
                                                                setChoice(triggerlabel +" "+1)
                                                                saveNode()
                                                                setAwaitingTrigger(performList ? false : true)
                                                            }
                                                        }}>
                                                            Test Trigger
                                                        </Button>
                                                    ) : (type == 'polling') && !testData ? (
                                                        <CircularProgress style={{ marginLeft: '30%', marginTop: '20px' }} id='circularprogresscolor' color={colors[color]} size={50} />
                                                    ) : null
                                                }
                                            </div>
                                        </div>
                                    )
                                    }
                                </div>
                            </StepContent>
                        </Step>
                    </Stepper>
                    <div style={{ width: '90%', height: '1px' }}></div>
                    {activeStep === 88 && triggerError ? (
                        <Paper square elevation={0} className={classes.resetContainer}>
                             <Alert severity="error" variant="outlined" style={{borderLeft: '4px solid red'}}>
                                    <strong>{triggerError.error.name}</strong> - {triggerError.error.message}<br/>Request ID: {triggerError.meta.requestId}
                                </Alert>
                                <div style={{margin:'auto', width: '100%', maxWidth: '100%', justifyContent: 'center', alignText: 'center', minWidth: 0 }}>
                                   <div style={{ width: '100%', alignText: 'center', padding: '10px', marginTop: '25px'}}> <FlashOffRoundedIcon style={{color: 'gray', fontSize: '44px',display: 'flex', justifyContent:'center',margin: 'auto', left: 50,right:50}} /> </div>
                                   <div style={{ width: '100%', alignText: 'center', padding: '10px', marginBottom: '25px'}}> <Typography style={{color: 'gray', fontSize: '32px',display: 'flex', justifyContent:'center',margin: 'auto', left: 50,right:50}}>Nothing found...</Typography> </div>
                                    </div>
                                    <Button style={{width: '100%', textTransform: 'none', marginBottom: '20px'}} disabled={nosave} variant='contained' color='primary' onClick={() => { flushFormThenSave((latest) => { saveNode(null, latest); dispatch(saveWorkflow(1)); sendAlert(); setStep(1); }); }}>
                                            <Typography style={{fontSize: '20px'}}>Try again</Typography>
                                        </Button>
                                        <Button style={{width: '100%', textTransform: 'none'}} variant='text' onClick={() => { flushFormThenSave((latest) => { saveNode(null, latest); dispatch(saveWorkflow(1)); onPaneClick(); sendAlert(); handleNextNodeOpen(); }); }} >
                                            Skip & continue
                                        </Button>
                                
                                            
                            
                            </Paper>
                    ) : null}
                    {activeStep === 99 ? (

                        <Paper square elevation={0} className={classes.resetContainer}>

                            {
                               !triggerChoices && !triggerMessage && awaitingTrigger === true ? <>
                                    <div style={{ margin: 'auto', justifyContent: 'center', alignItems: 'center', alignText: 'center', display: 'flex' }}>
                                        <img style={{ width: breakpoint === 'small' ? '36px' : '48px', height: breakpoint === 'small' ? '36px' : '48px' }} src={icon} />
                                        <img style={{ width: breakpoint === 'small' ? '36px' : '48px', height: breakpoint === 'small' ? '36px' : '48px' }} src='https://cdn.workload.co/wp-content/uploads/connection-animated.gif' />
                                        <img style={{ width: breakpoint === 'small' ? '36px' : '48px', height: breakpoint === 'small' ? '36px' : '48px', marginRight: breakpoint === 'small' ? '4px' : '10px' }} src='https://cdn.workload.co/wp-content/uploads/workload-icon.png' />
                                        <br />
                                    </div>
                                    <div style={{ margin: 'auto', display: 'flex', alignText: 'center', justifyContent: 'center' }}>
                                        <Typography style={{ fontWeight: 'bold', fontSize: breakpoint === 'small' ? '18px' : '22px', paddingTop: breakpoint === 'small' ? '10px' : '5px' }}>We're listening for data</Typography>
                                    </div><br/><br/>
                                    <Button variant="outlined" style={{marginTop: '16px', marginBottom: '16px', textTransform: 'none', margin: 'auto', display: 'flex', alignText: 'center', justifyContent: 'center' }} onClick={()=>  {
                                        setAwaitingTrigger(false);
                                        dispatch(activeUpdated(false));
                                        dispatch(saveWorkflow(1));
                                        handleSaveClick();
                                        setTimeLeft(61);
                                    setStep(testStep)}} className={classes.button}>Cancel</Button><br/><br/>

                                   {/*  <Box position="relative" display="inline-flex" style={{ width: '100%', margin: 'auto', marginTop: '20px', marginBottom: '20px', justifyContent: 'center', alignItems: 'center' }}>
                                        <CircularProgress
                                            // style={{ }} 
                                            variant='determinate'
                                            value={timeLeft / 61 * 100}
                                            id='circularprogresscolor'
                                            color="primary"
                                            size={60} />
                                        <Box
                                            top={18}
                                            left={10}
                                            bottom={0}
                                            width='97%'
                                            position="absolute"
                                            display="flex"
                                            alignnItems="center"
                                            justifyContent="center"
                                        >
                                            <Typography style={{ fontWeight: 'bold', fontSize: '18px' }} component="div" color="black">{timeLeft}s</Typography>
                                        </Box>
                                    </Box> */}
                                    </>
                                    : null
                            }
                            {
                                // Show empty state message when no choices found after loading completes (for polling and schedule triggers)
                                (type === 'polling' || app === 'schedule') && !loadingchoices && (!triggerChoices || !Array.isArray(triggerChoices) || triggerChoices.length === 0) && !awaitingTrigger ? (
                                    <Fragment>
                                        <Alert severity="warning" variant="outlined" style={{borderWidth: '0px 0px 0px 6px', borderStyle: 'none none none solid', marginTop: '20px'}}>
                                            <AlertTitle>No {triggerlabel} found</AlertTitle>
                                            <Typography variant="body2">
                                                Sorry, Workload didn't find any {triggerlabel.toLowerCase()} that match your trigger settings. Either create a {triggerlabel.toLowerCase()} in your {label} account or adjust your trigger's settings and try again.
                                            </Typography>
                                        </Alert>
                                        <div style={{ marginTop: '20px', textAlign: 'center' }}>
                                            <Button 
                                                variant="outlined" 
                                                color="primary" 
                                                style={{ textTransform: 'none', marginRight: '10px' }}
                                                onClick={() => {
                                                    // Go back to trigger setup step to adjust settings
                                                    setStep(3)
                                                }}
                                            >
                                                Adjust Settings
                                            </Button>
                                            <Button 
                                                variant="text" 
                                                style={{ textTransform: 'none' }}
                                                onClick={() => {
                                                    // Try fetching again
                                                    handlePerformList()
                                                }}
                                            >
                                                Try Again
                                            </Button>
                                        </div>
                                    </Fragment>
                                ) : triggerChoices && Array.isArray(triggerChoices) && triggerChoices.length > 0 && !loadingchoices && !loadingRecentPayloads ?
                              
                                    <Fragment>

                                        <Alert severity="success" variant="outlined" style={{borderWidth: '0px 0px 0px 6px', borderStyle: 'none none none solid'}}>
                                        <AlertTitle>{triggerlabel} found!</AlertTitle>
                                            {triggerlabel} was fo!und in your {label} account...
                                        </Alert>
                                        {/* <IconButton color="primary" style={{ color: 'black', float: 'right', borderRadius: 50, marginTop: '-10px', marginRight: '15px' }} aria-label="close modal" onClick={handlePopClick}>
                                            <SettingsEthernetRoundedIcon style={{ color: 'black' }} />
                                        </IconButton>
                                        <Popper placement="left" id={id} open={openpop} anchorEl={anchorElPop} style={{ zIndex: 99 }}>
                                            <div className={classes.popper}>
                                                <React.Fragment>
                                                    <Typography color="inherit"><h4>Inject Sample Data</h4></Typography>
                                                    <em>{"And here's"}</em> <b>{'some'}</b> <u>{'amazing content'}</u>.{' '}
                                                    {"It's very engaging. Right?"}<br /><br />
                                                    <TextareaAutosize defaultValue={poptext} value={poptext} onChange={(e) => setPopText(e.target.value)} style={{ width: '350px', maxWidth: '350px', height: '200px', borderColor: 'lightgray', maxHeight: '250px', overflowY: 'scroll' }} aria-label="minimum height" minRows={40} placeholder='{"data":{&#10;"key1":"value1",&#10;"key2":"value2"&#10; }&#10;}' />
                                                    <br /><br />
                                                    <Button onClick={handlePopClose} style={{ marginRight: '5px' }}>Close</Button><Button onClick={() => { setTestData(JSON.parse(poptext)); handlePopClose() }} variant="contained" color="primary">Submit</Button>
                                                </React.Fragment>
                                            </div>
                                        </Popper> */}
                                         <Select
                                            MenuProps={{
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "left"
                                            },
                                            transformOrigin: {
                                                vertical: "top",
                                                horizontal: "left"
                                            },
                                            getContentAnchorEl: null
                                            }}
                                            id='trigger-select'
                                            style={{ width: '100%', padding: 0, marginTop: '12px', marginBottom: '12px' }}
                                            labelId="auth-select-outlined-label"
                                            defaultValue={triggerchoice}
                                            value={triggerchoice ?? triggerlabel+" 1"}
                                            renderValue={(value) => (<div><ListItemIcon style={{ float: 'left', display: 'block'}}>
                                            <Avatar style={{width: breakpoint === 'small' ? '18px' : '26px', height: breakpoint === 'small' ? '18px' : '26px' }} src={icon} />
                                        </ListItemIcon><Typography style={{ fontWeight: 'bold', fontSize: '20px',marginLeft: '8px', float:'left', display: 'block'}} >{value}</Typography></div>)}
                                            variant="outlined"
                                            //onChange={handleTriggerChoiceChange}
                                            placeholder={"Choose another trigger"}
                                            ><Typography style={{padding: '10px', fontWeight: 700}} variant="h6" >Choose another...</Typography>
                                            <Divider style={{marginBottom: '6px'}} />
                                            { triggerChoices.map((item, i) => loadingchoices === true ? <Skeleton animation="wave" height={85} style={{marginTop: '-25px'}} /> : <MenuItem onClick={() => setChoiceTestData(triggerChoices[i], i)} id={i} key={i} value={triggerlabel +" "+(i+1)}> <ListItemIcon style={{ float: 'left', display: 'block'}}>
                                            <Avatar style={{width: breakpoint === 'small' ? '18px' : '26px', height: breakpoint === 'small' ? '18px' : '26px' }} src={icon} />
                                        </ListItemIcon><Typography style={{ fontWeight: 'bold', fontSize: '20px',marginLeft: '8px', float:'left', display: 'block'}} >{triggerlabel} {i + 1}<br/><div style={{fontSize: '12px', fontWeight: 300}}>{"Fetched "+timeSince(triggerChoiceTime)+" ago"}</div></Typography>
                                      </MenuItem>)}
                                      <div>
                                        <br /><button size="small" id='new-auth-button' labelId='new-auth-button-label'
                                        className={classes.loadbutton} color="primary"
                                        variant="outlined"
                                        onClick={(e) => {handleLoadMorePerformList(e); setTriggerChoiceTime(Date.now()); saveNode()}}
                                        >{loadingchoices === true ? <CircularProgress size={18} color={colors[color]} /> : <Typography style={{ color: '#0069ea', fontSize: breakpoint !== 'large' ? '12px' : null }} >Load More</Typography>}</button>
                                        </div>
                                        </Select> 
                                        
                                        <div id='inspector-json' style={{ maxHeight: '350px', overflowX: 'hidden', overflowY: 'scroll' }}>
                                        
                                            <DataInspector data={testData} testData={node.data.testData} />
                                        </div>
                                        
                                        <br /><br />

                                        <div id='trigger-save' style={{ width: '90%', height: '1px' }}></div>
                                        
                                        <Button style={{width: '100%', textTransform: 'none', marginBottom: '20px'}} disabled={nosave} variant='contained' color='primary' onClick={() => { flushFormThenSave((latest) => { saveNode(null, latest); dispatch(saveWorkflow(1)); sendAlert(); handleNextNodeOpen(); }); }}>
                                            <Typography style={{fontSize: '20px'}}>Continue</Typography>
                                        </Button>
                                        <Button style={{width: '100%', textTransform: 'none'}} variant='text' onClick={() => { flushFormThenSave((latest) => { saveNode(null, latest); dispatch(saveWorkflow(1)); onPaneClick(); sendAlert(); }); }} >
                                            Close
                                        </Button>


                                    </Fragment>  : testData && testData !== "" && (!triggerChoices || (Array.isArray(triggerChoices) && triggerChoices.length === 0)) ? 

                                    <Fragment>

                                    <Alert severity="success" variant="outlined" style={{borderLeft: '4px solid green'}}>
                                    <AlertTitle>{triggerlabel} found!</AlertTitle>
                                        {triggerlabel} was found in your {label} account...
                                    </Alert>
                                    {/* <IconButton color="primary" style={{ color: 'black', float: 'right', borderRadius: 50, marginTop: '-10px', marginRight: '15px' }} aria-label="close modal" onClick={handlePopClick}>
                                        <SettingsEthernetRoundedIcon style={{ color: 'black' }} />
                                    </IconButton>
                                    <Popper placement="left" id={id} open={openpop} anchorEl={anchorElPop} style={{ zIndex: 99 }}>
                                        <div className={classes.popper}>
                                            <React.Fragment>
                                                <Typography color="inherit"><h4>Inject Sample Data</h4></Typography>
                                                <em>{"And here's"}</em> <b>{'some'}</b> <u>{'amazing content'}</u>.{' '}
                                                {"It's very engaging. Right?"}<br /><br />
                                                <TextareaAutosize defaultValue={poptext} value={poptext} onChange={(e) => setPopText(e.target.value)} style={{ width: '350px', maxWidth: '350px', height: '200px', borderColor: 'lightgray', maxHeight: '250px', overflowY: 'scroll' }} aria-label="minimum height" minRows={40} placeholder='{"data":{&#10;"key1":"value1",&#10;"key2":"value2"&#10; }&#10;}' />
                                                <br /><br />
                                                <Button onClick={handlePopClose} style={{ marginRight: '5px' }}>Close</Button><Button onClick={() => { setTestData(JSON.parse(poptext)); handlePopClose() }} variant="contained" color="primary">Submit</Button>
                                            </React.Fragment>
                                        </div>
                                    </Popper> */}
                                    
                                    <div id='inspector-json' style={{ maxHeight: '350px', overflowX: 'hidden', overflowY: 'scroll' }}>

                                    <DataInspector data={testData} finalStep={true} testData={node.data.testData} />
                                    </div>
                                    <br /><br />

                                    <div id='trigger-save' style={{ width: '90%', height: '1px' }}></div>

                                    <Button style={{width: '100%', textTransform: 'none', marginBottom: '20px'}} disabled={nosave} variant='contained' color='primary' onClick={() => { flushFormThenSave((latest) => { saveNode(null, latest); dispatch(saveWorkflow(1)); sendAlert(); handleNextNodeOpen(); }); }}>
                                        <Typography style={{fontSize: '20px'}}>Continue</Typography>
                                    </Button>
                                    <Button style={{width: '100%', textTransform: 'none'}} variant='text' onClick={() => { flushFormThenSave((latest) => { saveNode(null, latest); dispatch(saveWorkflow(1)); onPaneClick(); sendAlert(); }); }} >
                                        Close
                                    </Button>


                                    </Fragment>


                                    :
                                    awaitingTrigger === true ?
                                        <Fragment>
                                            <Alert severity="info">
                                                <AlertTitle>Waiting for response data</AlertTitle>
                                                {app === 'webhook' && type === 'webhook' && recentWebhookPayloads.length > 0 ? (
                                                    <>
                                                        <strong>Recent payloads available!</strong> You can either wait for a new webhook or select from recent payloads above.<br />
                                                        To wait for a new webhook:<br />
                                                        1. Send a webhook to your webhook URL.<br />
                                                        2. The data will appear below automatically.<br />
                                                        3. You can reference this data in following steps.<br />
                                                    </>
                                                ) : (
                                                    <>
                                                Whats happening now? Workload is now waiting for you to do the event <strong>{trigger.label}</strong> within <strong>{label}</strong>. You must now follow these steps:<br />
                                                1. Open <strong>{label}</strong>.<br />
                                                2. In <strong>{label}</strong>, perform the action <strong>{trigger.label}</strong>.<br />
                                                3. The data from your <strong>{trigger.label}</strong> will appear below.<br />
                                                4. You can reference this data in following steps.<br />
                                                    </>
                                                )}
                                            </Alert>
                                            {loadingRecentPayloads && (
                                                <CircularProgress style={{ margin: '20px auto', display: 'block' }} size={30} />
                                            )}
                                        </Fragment> : null
                            }
                        </Paper>
                       

                    ) :
                        null}
                    <div ref={bottomRef} />
                    <Modal
        open={modalopen}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {modalbody}
      </Modal>
                </div>

        )
    } catch (e) {
        var airtableConfig = {
            method: 'post',
            url: 'https://api.airtable.com/v0/appb76LyMibAJXsfE/FrontendErrors',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${config.AIRTABLE_API_KEY}`
            },
            data: {
                'records': [
                    {
                        'fields': {
                            'Error source': 'Trigger Panel',
                            'Error': e.toString()
                        }
                    }
                ]
            }
        }

        axios(airtableConfig)

        onPaneClick();
    }
}

// Wrap TriggerPanel with error boundary
const TriggerPanelWithErrorBoundary = (props) => {
  return (
    <WorkflowErrorBoundary 
      componentName="TriggerPanel"
      workflowId={props.workflowID}
      nodeId={props.selectedNode?.id}
    >
      <TriggerPanel {...props} />
    </WorkflowErrorBoundary>
  );
};

export default TriggerPanelWithErrorBoundary;

